(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["addiesdive-acessorio-relogios"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ad-accessory-related')) {
  customElements.define('ad-accessory-related', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const featured = this.querySelector('[data-related-featured]');
      const list = this.querySelector('[data-related-list]');
      const cards = Array.from(this.querySelectorAll('[data-related-card]'));
      const byHandle = new Map(cards.map(card => [card.dataset.handle, card]));
      const storageKey = 'ad-accessory-origin:' + this.dataset.accessoryHandle;
      const current = new URL(window.location.href);
      let origin = null;
      const explicitHandle = current.searchParams.get('ad_from');
      if (byHandle.has(explicitHandle)) origin = {handle: explicitHandle, variant: current.searchParams.get('ad_from_variant')};
      if (!origin && document.referrer) {
        try {
          const referrer = new URL(document.referrer);
          if (referrer.origin === current.origin) {
            const match = referrer.pathname.match(/\/products\/([^/]+)\/?$/);
            if (match && byHandle.has(match[1])) origin = {handle: match[1], variant: referrer.searchParams.get('variant')};
            else if (match && referrer.pathname !== current.pathname) {
              try { sessionStorage.removeItem(storageKey); } catch {}
              return;
            }
          }
        } catch {}
      }
      if (!origin) {
        try {
          const saved = JSON.parse(sessionStorage.getItem(storageKey));
          if (saved && saved.expires > Date.now() && byHandle.has(saved.handle)) origin = saved;
        } catch {}
      }
      if (!origin) return;
      const chosen = byHandle.get(origin.handle);
      let target;
      try {
        target = new URL(chosen.dataset.url, current.origin);
        if (target.origin !== current.origin) return;
      } catch { return; }
      let variants = [];
      try { variants = JSON.parse(chosen.dataset.variants); } catch {}
      const variant = variants.find(item => String(item.id) === String(origin.variant));
      if (variant) {
        target.searchParams.set('variant', String(variant.id));
        const image = chosen.querySelector('.ad-ar__image');
        if (variant.image && image) {
          image.removeAttribute('srcset');
          image.src = variant.image;
          image.alt = chosen.querySelector('.ad-ar__product-title').textContent.trim() + ' — ' + variant.title;
          const label = chosen.querySelector('[data-origin-variant]');
          if (variant.title !== 'Default Title') { label.textContent = variant.title; label.hidden = false; }
        }
      }
      if (featured.firstElementChild !== chosen && list) {
        const previous = featured.firstElementChild;
        featured.replaceChildren(chosen);
        if (previous) list.prepend(previous);
      }
      const link = chosen.querySelector('[data-related-link]');
      link.href = target.toString();
      link.textContent = this.dataset.returnButton;
      this.querySelector('[data-related-heading]').textContent = this.dataset.returnHeading;
      this.querySelector('[data-related-copy]').textContent = this.dataset.returnCopy;
      try { sessionStorage.setItem(storageKey, JSON.stringify({handle: origin.handle, variant: variant ? String(variant.id) : null, expires: Date.now() + 2 * 60 * 60 * 1000})); } catch {}
      this.dataset.hasOrigin = 'true';
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["addiesdive-avalicao"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('addies-reviews-loja')) {
    customElements.define('addies-reviews-loja', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const controller = this.controller;
        requestAnimationFrame(() => {
          if (this.isConnected && !controller.signal.aborted) this.initialize(controller.signal);
        });
      }
      initialize(signal) {
        this.reviews = Array.from(this.querySelectorAll('[data-review]'));
        this.controls = this.querySelector('[data-controls]');
        if (this.dataset.mode !== 'carousel' || this.reviews.length < 2 || !this.controls) return;
        this.current = 0;
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.counter = this.querySelector('[data-counter]');
        this.controls.hidden = false;
        this.classList.add('is-ready');
        this.previous.addEventListener('click', () => this.show(this.current - 1), { signal });
        this.next.addEventListener('click', () => this.show(this.current + 1), { signal });
        this.controls.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.show(this.current + (event.key === 'ArrowRight' ? 1 : -1));
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          const index = this.reviews.findIndex(review => review.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.show(index);
        }, { signal });
        this.show(0);
      }
      show(requested) {
        const total = this.reviews.length;
        const loop = this.dataset.loop === 'true';
        this.current = loop ? (requested + total) % total : Math.min(total - 1, Math.max(0, requested));
        this.reviews.forEach((review, index) => {
          review.hidden = index !== this.current;
          review.setAttribute('aria-hidden', String(index !== this.current));
        });
        this.previous.disabled = !loop && this.current === 0;
        this.next.disabled = !loop && this.current === total - 1;
        this.counter.textContent = this.dataset.position.replaceAll('[atual]', String(this.current + 1)).replaceAll('[total]', String(total));
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.classList.remove('is-ready');
        this.reviews?.forEach(review => { review.hidden = false; review.removeAttribute('aria-hidden'); });
        if (this.controls) this.controls.hidden = true;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["addiesdive-best-sellers"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('addies-bestsellers-collection')) {
  customElements.define('addies-bestsellers-collection', class extends HTMLElement {
    connectedCallback() {
      this.setupFrame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (!this.isConnected) return;
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.track = this.querySelector('.ad-bs__track');
      this.navigation = this.querySelector('.ad-bs__navigation');
      this.previous = this.querySelector('[data-direction="-1"]');
      this.next = this.querySelector('[data-direction="1"]');
      this.progress = this.querySelector('.ad-bs__progress span');
      this.status = this.querySelector('[data-bs-status]');
      if (!this.track) return;
      const update = () => {
        cancelAnimationFrame(this.updateFrame);
        this.updateFrame = requestAnimationFrame(() => this.update());
      };
      this.addEventListener('click', event => this.click(event), options);
      this.addEventListener('keydown', event => {
        const variant = event.target.closest('[data-bs-variant]');
        if (variant && event.key === ' ') {event.preventDefault();variant.click();}
      }, options);
      this.track.addEventListener('scroll',update,{...options,passive:true});
      this.previous?.addEventListener('click',()=>this.move(-1),options);
      this.next?.addEventListener('click',()=>this.move(1),options);
      window.addEventListener('resize',update,options);
      window.addEventListener('storage',()=>this.syncWishlist(),options);
      document.addEventListener('ad-bestsellers:wishlist',()=>this.syncWishlist(),options);
      if ('ResizeObserver' in window) {this.observer=new ResizeObserver(update);this.observer.observe(this.track);}
      this.addEventListener('error',event=>{
        if (!event.target.matches?.('.ad-bs__main-image')) return;
        event.target.hidden=true;
        event.target.closest('[data-bs-card]').querySelector('.ad-bs__missing').hidden=false;
      },{...options,capture:true});
      this.update();this.syncWishlist();
    }
    click(event) {
      const wish = event.target.closest('[data-bs-wish]');
      if (wish) {event.preventDefault();this.toggleWishlist(wish);return;}
      const variant = event.target.closest('[data-bs-variant]');
      if (!variant || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      const card = variant.closest('[data-bs-card]');
      card.querySelectorAll('[data-bs-variant]').forEach(el=>el.setAttribute('aria-pressed',String(el===variant)));
      card.querySelectorAll('[data-bs-product-link]').forEach(el=>el.href=variant.href);
      const price=card.querySelector('[data-bs-price]');if(price)price.textContent=variant.dataset.price;
      const compare=card.querySelector('[data-bs-compare]');if(compare){compare.textContent=variant.dataset.compare;compare.hidden=variant.dataset.sale!=='true';}
      card.querySelector('[data-bs-sold-out]').hidden=variant.dataset.available==='true';
      card.querySelector('[data-bs-variant-name]').textContent=variant.dataset.label;
      const image=card.querySelector('.ad-bs__main-image');
      image.alt=card.dataset.productTitle+' — '+variant.dataset.label;
      image.hidden=!variant.dataset.image;
      card.querySelector('.ad-bs__missing').hidden=!!variant.dataset.image;
      if (variant.dataset.image) {image.setAttribute('srcset',variant.dataset.srcset);image.setAttribute('src',variant.dataset.image);}
      else {image.removeAttribute('srcset');image.removeAttribute('src');}
      this.status.textContent=variant.dataset.label+' — '+variant.dataset.price;
      this.update();
    }
    readWishlist() {
      const result=JSON.parse(localStorage.getItem('ks-wishlist')||'[]');
      return Array.isArray(result)?result:[];
    }
    syncWishlist() {
      let list=[];try{list=this.readWishlist();}catch{}
      this.querySelectorAll('[data-bs-wish]').forEach(button=>{
        const url=button.closest('[data-bs-card]').dataset.productUrl;
        const active=list.some(item=>item.url===url);
        button.setAttribute('aria-pressed',String(active));button.setAttribute('aria-label',active?button.dataset.remove:button.dataset.add);
      });
    }
    toggleWishlist(button) {
      const card=button.closest('[data-bs-card]'),data=card.dataset;
      try {
        let list=this.readWishlist();const exists=list.some(item=>item.url===data.productUrl);
        list=list.filter(item=>item.url!==data.productUrl);
        if(!exists)list.push({url:data.productUrl,id:Number(data.productId),handle:data.productHandle,title:data.productTitle,img_src:data.productImage,img_alt:data.productTitle,price:Number(data.productPrice),compare_at_price:Number(data.productCompare),price_varies:data.productPriceVaries==='true',added_at:Date.now()});
        localStorage.setItem('ks-wishlist',JSON.stringify(list));
        document.dispatchEvent(new CustomEvent('ad-bestsellers:wishlist'));
        document.querySelectorAll('.wishlist-count-badge').forEach(el=>{el.textContent=String(list.length);el.dataset.count=String(list.length);});
        document.querySelectorAll('wishlist-container').forEach(el=>{try{el.setCountBadges?.();el.setContent?.();}catch{}});
        document.querySelectorAll('wishlist-button').forEach(el=>{try{el.adjustBtn?.();}catch{}});
        this.status.textContent=exists?this.dataset.removed:this.dataset.added;
      } catch {this.status.textContent=this.dataset.wishlistError;}
    }
    move(direction) {
      const cards=[...this.track.querySelectorAll('.ad-bs__card')];if(!cards.length)return;
      const max=Math.max(0,this.track.scrollWidth-this.track.clientWidth),position=Math.max(0,Math.min(max,this.track.scrollLeft));
      const origin=cards[0].offsetLeft,points=cards.map(card=>Math.min(max,card.offsetLeft-origin));
      const left=direction>0?(points.find(point=>point>position+2)??max):([...points].reverse().find(point=>point<position-2)??0);
      this.track.scrollTo({left,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    }
    update() {
      if(!this.track||!this.isConnected)return;
      const max=Math.max(0,this.track.scrollWidth-this.track.clientWidth),position=Math.max(0,Math.min(max,this.track.scrollLeft));
      if(this.navigation)this.navigation.hidden=max<=2||this.dataset.navigation==='false';
      if(this.previous)this.previous.disabled=position<=2;
      if(this.next)this.next.disabled=position>=max-2;
      const ratio=Math.min(1,this.track.clientWidth/Math.max(1,this.track.scrollWidth));
      if(this.progress){this.progress.style.width=ratio*100+'%';this.progress.style.transform='translateX('+(max>0?position/max*(1-ratio)/ratio*100:0)+'%)';}
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.setupFrame);cancelAnimationFrame(this.updateFrame);this.controller?.abort();this.observer?.disconnect();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["addiesdive-blog"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('addies-blog-estilo')) {
    customElements.define('addies-blog-estilo', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => { if (this.isConnected) this.initialize(); });
      }
      initialize() {
        if (this.controller) return;
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.cards = [...this.track.children];
        this.controls = this.querySelector('[data-controls]');
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.counter = this.querySelector('[data-counter]');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.previous?.addEventListener('click', () => this.move(-1), { signal });
        this.next?.addEventListener('click', () => this.move(1), { signal });
        this.track.addEventListener('scroll', () => this.scheduleUpdate(), { signal, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1);
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault(); this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: this.motion.matches ? 'auto' : 'smooth' });
          }
        }, { signal });
        this.resize = new ResizeObserver(() => this.scheduleUpdate());
        this.resize.observe(this.track);
        this.update();
      }
      step() { return (this.cards[0]?.getBoundingClientRect().width || 0) + (parseFloat(getComputedStyle(this.track).columnGap) || 0); }
      move(direction) { this.track.scrollBy({ left: direction * this.step(), behavior: this.motion.matches ? 'auto' : 'smooth' }); }
      scheduleUpdate() { cancelAnimationFrame(this.updateFrame); this.updateFrame = requestAnimationFrame(() => this.update()); }
      update() {
        const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const scrollable = getComputedStyle(this.track).overflowX === 'auto' && maximum > 2;
        if (this.controls) this.controls.hidden = !scrollable;
        if (this.previous) this.previous.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= maximum - 2;
        if (this.counter) {
          const current = Math.min(this.cards.length, Math.max(1, Math.round(this.track.scrollLeft / (this.step() || 1)) + 1));
          this.counter.textContent = this.dataset.position.replaceAll('[atual]', String(current)).replaceAll('[total]', String(this.cards.length));
        }
      }
      disconnectedCallback() { cancelAnimationFrame(this.frame); cancelAnimationFrame(this.updateFrame); this.resize?.disconnect(); this.controller?.abort(); this.controller = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["addiesdive-colecao-grade"] && !Shopify.designMode) return;
  try {
    
const AdgFilterLogic = (() => {
  const normalize = value => String(value ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, ' ').trim();
  const defaults = {
    material: { steel: ['aço', 'steel', '316l', '316 l'], titanium: ['titânio', 'titanium'] },
    movement: { automatic: ['automático', 'automatic'], quartz: ['quartzo', 'quartz'], mecha: ['meca-quartz', 'mecha-quartz', 'meca quartz', 'mecha quartz'] },
    glass: { sapphire: ['safira', 'sapphire'], mineral: ['mineral', 'hardlex'], acrylic: ['acrílico', 'acrylic', 'plexiglass'] },
    strap: { steel: ['aço', 'steel', '316l'], titanium: ['titânio', 'titanium'], leather: ['couro', 'leather'], fkm: ['fkm', 'fluoroelastômero'], nylon: ['nylon'], silicone: ['silicone'], rubber: ['borracha', 'rubber'], textile: ['tecido', 'textile'] },
    features: { gmt: ['gmt'], chronograph: ['cronógrafo', 'chronograph'], calendar: ['data', 'calendário', 'date'], hours24: ['24 horas', '24-hour'] }
  };
  const dimensions = (raw, multiple = false) => {
    const text = normalize(raw);
    const pattern = /((?:\d+(?:[.,]\d+)?\s*\/\s*)*\d+(?:[.,]\d+)?)\s*mm\b/g;
    const found = [...text.matchAll(pattern)].flatMap(m => m[1].split('/').map(n => Number(n.trim().replace(',', '.'))));
    return [...new Set(multiple ? found : found.slice(0, 1))];
  };
  const water = raw => {
    const text = normalize(raw);
    let found = [...text.matchAll(/(\d+(?:[.,]\d+)?)\s*m\b/g)].map(m => Number(m[1].replace(',', '.')));
    if (!found.length) found = [...text.matchAll(/(\d+(?:[.,]\d+)?)\s*(?:atm|bar)\b/g)].map(m => Number(m[1].replace(',', '.')) * 10);
    return [...new Set(found)];
  };
  const classify = (raw, rules) => Object.entries(rules || {}).filter(([, terms]) => Array.isArray(terms) && terms.some(term => normalize(term) && normalize(raw).includes(normalize(term)))).map(([key]) => key);
  const caseMaterial = (raw, rules) => {
    const text = normalize(raw).split(/\bfundo\b|\bcaseback\b/)[0];
    const bronze = text.indexOf('bronze');
    const matches = classify(text, rules).map(key => ({key, position: Math.min(...rules[key].map(term => text.indexOf(normalize(term))).filter(n => n >= 0))})).sort((a,b) => a.position - b.position);
    if (!matches.length || (bronze >= 0 && bronze < matches[0].position)) return [];
    return [matches[0].key];
  };
  const strapMaterial = (raw, rules) => {
    const main = normalize(raw).split(/\bfivela\b|\bfecho\b|\bbuckle\b|\bclasp\b/)[0];
    let values = classify(main, rules);
    if (values.includes('fkm')) values = values.filter(v => v !== 'rubber');
    if (values.includes('nylon')) values = values.filter(v => v !== 'textile');
    return values;
  };
  const category = record => /^(pulseira|peca|acessorio)/.test(normalize(record.type)) ? 'accessory' : 'watch';
  const cleanValue = value => normalize(value).replace(/[^a-z0-9.-]+/g, '-');
  const factCache = new WeakMap();
  const facts = (record, variant, rules = defaults) => {
    let ruleCache = factCache.get(record);
    if (!ruleCache) { ruleCache = new WeakMap(); factCache.set(record, ruleCache); }
    let variantCache = ruleCache.get(rules);
    if (!variantCache) { variantCache = new WeakMap(); ruleCache.set(rules, variantCache); }
    if (variantCache.has(variant)) return variantCache.get(variant);
    const meta = record.meta || {};
    const family = category(record);
    const options = record.optionNames.map((name, i) => [normalize(name), variant.options?.[i] || '']);
    const option = names => options.find(([name]) => names.includes(name))?.[1];
    let strap = meta.pulseira || '';
    const explicitStrap = option(['material da pulseira', 'pulseira', 'material']);
    if (explicitStrap && strapMaterial(explicitStrap, rules.strap).length) strap = explicitStrap;
    const explicitCalibre = option(['calibre', 'mecanismo', 'movimento']);
    const dial = option(['cor do mostrador', 'mostrador']);
    const accessoryColor = family === 'accessory' ? option(['cor', 'color', 'colour']) : '';
    const width = option(['largura', 'largura da pulseira', 'tamanho']);
    const f = {
      availability: [variant.available ? 'available' : 'soldout'],
      price: Number(variant.price),
      strap: strapMaterial(strap, rules.strap),
      width: dimensions(width || meta.largura_pulseira, true).map(String)
    };
    if (family === 'watch') {
      f.material = caseMaterial(meta.caixa, rules.material);
      f.movement = classify(meta.movimento, rules.movement);
      f.glass = classify(meta.vidro, rules.glass);
      f.diameter = dimensions(meta.diametro_mostrador).map(String);
      f.water = water(meta.resistencia_agua).map(String);
      f.features = classify(meta.funcao, rules.features);
      if (/\bsem\s+(?:data|calendario)\b/.test(normalize(meta.funcao))) f.features = f.features.filter(v => v !== 'calendar');
      f.color = (dial ? [dial] : record.dialColors || []).filter(Boolean).map(cleanValue);
      f.calibre = [...new Set(normalize(explicitCalibre || meta.calibre).match(/\b(?:nh\d+[a-z]?|vk\d+|vh\d+|pt\d+|\d{3,4}[a-z]?|0s\d+|gm\d+|sl\d+)\b/g) || [])];
    } else {
      f.color = accessoryColor ? [cleanValue(accessoryColor)] : [];
      const componentRules = { crown:['coroa','crown'], bezel:['bisel','luneta','bezel','inserto'], dial:['mostrador','dial'], crystal:['vidro','cristal','crystal'], hands:['ponteiro','hands'], clasp:['fecho','fivela','clasp'], case:['caixa'], pins:['pino','mola','spring bar'], movement:['movimento','mecanismo'] };
      f.component = /^peca/.test(normalize(record.type)) ? classify(record.title, componentRules) : [];
      f.compatibility = /\bpara\b|compativ/.test(normalize(meta.modelo)) ? [...new Set((meta.modelo || '').toUpperCase().match(/\b(?:AD\d+[A-Z]?|AW\d+[A-Z]?|H\d+[A-Z]*|MY-[A-Z0-9-]+)\b/g) || [])] : [];
    }
    variantCache.set(variant, f);
    return f;
  };
  const matches = (f, state, exclude) => {
    if (exclude !== 'price' && ((state.min !== null && f.price < state.min) || (state.max !== null && f.price > state.max))) return false;
    return Object.entries(state.values).every(([key, selected]) => key === exclude || !selected.length || selected.some(v => (f[key] || []).includes(v)));
  };
  const variantsMatching = (record, state, rules, exclude) => record.variants.filter(v => matches(facts(record, v, rules), state, exclude));
  const count = (records, state, key, value, rules) => records.filter(r => r.variants.some(v => {const f=facts(r,v,rules);return (f[key] || []).includes(value) && matches(f,state,key);})).length;
  return {normalize, defaults, dimensions, water, classify, caseMaterial, strapMaterial, facts, matches, variantsMatching, count, category, cleanValue};
})();

class AdgCustomFilters {
  constructor(root) {
    this.root = root;
    this.config = JSON.parse(root.querySelector('[data-adg-custom-config]').textContent);
    this.labels = this.config.labels;
    this.rules = JSON.parse(JSON.stringify(AdgFilterLogic.defaults));
    try {
      const extra = JSON.parse(this.config.rules || '{}');
      for (const key of Object.keys(this.rules)) if (extra[key] && typeof extra[key] === 'object') Object.assign(this.rules[key], extra[key]);
    } catch (_) {}
    this.cache = new Map();
    this.records = [];
    this.state = this.readURL();
    this.sort = this.state.sort;
    this.seed = this.readPage(root);
    this.collect(root);
    this.seedCache = new Map(this.cache);
    this.grid = root.querySelector('.adg-grid');
    this.pagination = root.querySelector('.adg-pagination');
    this.quick = root.querySelector('[data-adg-custom-quick]');
    this.drawer = root.querySelector('[data-adg-custom-fields]');
    this.chips = root.querySelector('[data-adg-custom-active]');
    this.status = root.querySelector('[data-adg-custom-status]');
    const options = {signal: root.abort.signal};
    this.accordions = new WeakMap();
    root.addEventListener('click', e => this.onClick(e), options);
    root.addEventListener('submit', e => this.onSubmit(e), options);
    root.addEventListener('input', e => this.previewForm(e), options);
    root.addEventListener('change', e => this.previewForm(e), options);
    window.addEventListener('popstate', () => {
      this.state = this.readURL();
      const select = root.querySelector('[data-adg-sort]');
      if (select) select.value = this.state.sort;
      this.withData(() => this.render());
    }, options);
    this.buildQuickShell();
    const restore = Object.keys(this.state.values).length || this.state.min !== null || this.state.max !== null || [...new URL(location.href).searchParams.keys()].some(k => k.startsWith('filter.'));
    this.withData(() => { if (restore) this.render(); });
  }
  readURL() {
    const params = new URL(location.href).searchParams;
    const values = {};
    for (const key of this.config.groups) {
      const list = params.getAll('adg_' + key).filter(v => v && v.length < 160 && (key !== 'material' || ['steel','titanium'].includes(v)));
      if (list.length) values[key] = [...new Set(list)];
    }
    const amount = name => {const value=params.get(name);return value !== null && value.trim() && Number.isFinite(Number(value)) && Number(value)>=0 ? Math.round(Number(value)*100) : null;};
    return {values, min:amount('adg_min'), max:amount('adg_max'), page:Math.max(1,Math.floor(Number(params.get('page'))||1)), sort:params.get('sort_by') || this.config.sort};
  }
  readPage(scope) {
    const node = scope.querySelector('[data-adg-custom-page]');
    if (!node) throw new Error('missing index');
    return JSON.parse(node.textContent);
  }
  collect(scope) {
    const page = this.readPage(scope);
    for (const record of page.products) {
      if (!this.cache.has(String(record.id))) {
        const item = scope.querySelector('[data-adg-item-id="' + record.id + '"]');
        if (!item) throw new Error('missing card');
        this.cache.set(String(record.id), {record, node:item});
      }
    }
    return page;
  }
  async load() {
    if (this.loadedSort === this.state.sort) return;
    if (this.loadingSort === this.state.sort && this.promise) return this.promise;
    this.loadingSort = this.state.sort;
    this.loadedSort = null;
    const sort = this.state.sort;
    const generation = (this.generation || 0) + 1;
    this.generation = generation;
    this.promise = (async () => {
      this.message(this.labels.loading);
      const locationURL = new URL(location.href);
      const hasNative = [...locationURL.searchParams.keys()].some(k => k.startsWith('filter.'));
      const seedValid = this.seed.sort === sort && !hasNative;
      this.cache = new Map();
      let first;
      if (seedValid) {first=this.seed;this.cache=new Map(this.seedCache);} else {first=await this.fetchPage(1,sort,generation);}
      const pages = Math.max(1, first.pages);
      if (pages > 1000) throw new Error('catalog limit');
      const queue = Array.from({length:pages},(_,i)=>i+1).filter(n=>n!==first.page);
      const received = new Map([[first.page,first]]);
      const worker = async () => {
        while (queue.length) {
          if (generation !== this.generation) throw new DOMException('Superseded','AbortError');
          const n=queue.shift();
          const page=await this.fetchPage(n,sort,generation);
          if (page.page !== n || page.total !== first.total || page.pages !== pages) throw new Error('catalog changed');
          received.set(n,page);
        }
      };
      await Promise.all(Array.from({length:Math.min(3,queue.length)},worker));
      if (generation !== this.generation) throw new DOMException('Superseded','AbortError');
      const records = [...received.entries()].sort((a,b)=>a[0]-b[0]).flatMap(([,p])=>p.products);
      if (new Set(records.map(p=>p.id)).size !== first.total || this.cache.size !== first.total) throw new Error('incomplete index');
      this.records = records;
      this.loadedSort = sort;
      this.buildDefinitions();
      this.message('');
      this.buildFields();
    })();
    try {await this.promise;} finally {if(generation===this.generation){this.promise=null;this.loadingSort=null;}}
  }
  async fetchPage(page, sort, generation) {
    const url = new URL(this.config.url, location.origin);
    url.searchParams.set('section_id', this.config.section);
    url.searchParams.set('sort_by',sort);
    url.searchParams.set('page',String(page));
    const response=await fetch(url,{signal:this.root.abort.signal,credentials:'same-origin'});
    if (!response.ok) throw new Error('index response');
    const doc=new DOMParser().parseFromString(await response.text(),'text/html');
    if (generation !== this.generation) throw new DOMException('Superseded','AbortError');
    return this.collect(doc);
  }
  async withData(action) {
    try {await this.load();if(this.root.isConnected) await action();}
    catch(error) {if(error.name!=='AbortError' && this.root.isConnected)this.message(this.labels.error,true);}
  }
  message(text,retry=false) {
    this.status.replaceChildren(document.createTextNode(text));
    if(retry){const b=this.element('button',{type:'button','data-adg-custom-retry':''},this.labels.retry);this.status.append(' ',b);}
    const loading=this.drawer.querySelector('[data-adg-custom-loading]');
    if(loading)loading.textContent=text;
    if(retry){const note=this.element('p',{},text+' ');note.append(this.element('button',{type:'button','data-adg-custom-retry':''},this.labels.retry));this.drawer.replaceChildren(note);}
    this.status.hidden=!text;
  }
  element(tag, attributes={}, text) {
    const e=document.createElement(tag);
    for(const [key,value] of Object.entries(attributes))e.setAttribute(key,String(value));
    if(text!==undefined)e.textContent=text;
    return e;
  }
  label(key) {return this.labels[key] || key;}
  buildQuickShell() {
    this.quick.replaceChildren();
    this.quick.hidden = true;
  }
  buildDefinitions() {
    const definitions=[];
    const groups=this.config.groups;
    this.colorLabels=new Map();
    for(const r of this.records)for(const color of r.dialColors || [])this.colorLabels.set(AdgFilterLogic.cleanValue(color),color);
    for(const r of this.records)if(AdgFilterLogic.category(r)==='accessory')for(const v of r.variants)r.optionNames.forEach((name,i)=>{if(['cor','color','colour'].includes(AdgFilterLogic.normalize(name))){const color=v.options[i];if(color)this.colorLabels.set(AdgFilterLogic.cleanValue(color),color);}});
    for(const key of groups) {
      if(key==='price'){if(this.records.length)definitions.push({key,values:[]});continue;}
      const values=[...new Set(this.records.flatMap(r=>r.variants.flatMap(v=>AdgFilterLogic.facts(r,v,this.rules)[key] || [])))];
      if(key==='material' && values.length)for(const value of ['steel','titanium'])if(!values.includes(value))values.push(value);
      for(const selected of this.state.values[key] || [])if(!values.includes(selected))values.push(selected);
      values.sort((a,b)=>a.localeCompare(b,undefined,{numeric:true}));
      if(values.length)definitions.push({key,values});
    }
    this.definitions=definitions;
  }
  valueLabel(key,value) {
    if(['diameter','width'].includes(key))return new Intl.NumberFormat(this.config.locale).format(Number(value))+' mm';
    if(key==='water')return new Intl.NumberFormat(this.config.locale).format(Number(value))+' m';
    if(key==='color')return this.colorLabels.get(value)||value.replaceAll('-',' ');
    if(key==='calibre')return value.toUpperCase();
    return this.label(value);
  }
  optionsFor(key) {
    const values=this.definitions.find(d=>d.key===key)?.values || [];
    return values.map(value=>({value,selected:(this.state.values[key] || []).includes(value),count:AdgFilterLogic.count(this.records,this.state,key,value,this.rules)})).filter(option=>option.count>0 || option.selected);
  }
  visibleGroups() {
    return this.definitions.filter(def=>def.key==='price'
      ? this.state.min!==null || this.state.max!==null || this.records.some(record=>AdgFilterLogic.variantsMatching(record,this.state,this.rules,'price').length>0)
      : this.optionsFor(def.key).length>0);
  }
  fields(key, prefix) {
    const fieldset=this.element('fieldset',{class:'adg-facet-fields'});
    fieldset.append(this.element('legend',{class:'adg-sr-only'},this.label(key)));
    if(key==='price') {
      const bounds=this.element('div',{class:'adg-price-fields'});
      for(const [name,text,value] of [['adg_min',this.labels.from,this.state.min],['adg_max',this.labels.to,this.state.max]]) {
        const label=this.element('label',{},text+' ('+this.config.currency+')');
        label.append(this.element('input',{type:'number',name,min:'0',step:'0.01',inputmode:'decimal',value:value===null?'':String(value/100),'aria-label':text+' ('+this.config.currency+')'}));bounds.append(label);
      }
      fieldset.append(bounds);return fieldset;
    }
    const ul=this.element('ul',{class:'adg-facet-values'});
    for(const {value,selected,count} of this.optionsFor(key)) {
      const li=this.element('li');
      const label=this.element('label',{class:'adg-checkbox'});
      const input=this.element('input',{type:'checkbox',name:'adg_'+key,value});
      input.checked=selected;
      label.append(input,this.element('span',{},this.valueLabel(key,value)));
      li.append(label);ul.append(li);
    }
    fieldset.append(ul);return fieldset;
  }
  buildFields() {
    const current=document.activeElement;
    const previous=[...this.root.querySelectorAll('[data-adg-custom-drawer-key]')];
    const openKeys=previous.filter(e=>e.open).map(e=>e.dataset.adgCustomDrawerKey);
    const visible=this.visibleGroups();
    this.drawer.replaceChildren();
    for(const def of visible) {
      const details=this.element('details',{class:'adg-drawer-facet','data-adg-custom-drawer-key':def.key});
      details.open=openKeys.includes(def.key);
      details.append(this.element('summary',{},this.label(def.key)),this.fields(def.key,'drawer'));
      this.drawer.append(details);
    }
    let quickCount=0;
    for(const details of this.quick.querySelectorAll('[data-adg-custom-quick-key]')) {
      const key=details.dataset.adgCustomQuickKey;
      const def=visible.find(d=>d.key===key);
      details.hidden=!def;
      const form=details.querySelector('form');
      form.replaceChildren();
      if(def){form.append(this.fields(key,'quick'),this.element('button',{type:'submit',class:'adg-apply','data-adg-result-count':''},this.labels.apply));quickCount++;}
    }
    this.quick.hidden=quickCount===0;
    const opener=this.root.querySelector('[data-adg-open-filters]');
    if(opener)opener.hidden=visible.length===0;
    this.root.querySelectorAll('.adg-custom-form').forEach(form=>this.updateResultCount(form));
    if(current?.isConnected)current.focus({preventScroll:true});
  }
  getURL() {
    const url=new URL(location.href);
    for(const key of [...url.searchParams.keys()])if(key.startsWith('adg_')||key.startsWith('filter.')||key==='page')url.searchParams.delete(key);
    for(const [key,values] of Object.entries(this.state.values))for(const value of values)url.searchParams.append('adg_'+key,value);
    if(this.state.min!==null)url.searchParams.set('adg_min',String(this.state.min/100));
    if(this.state.max!==null)url.searchParams.set('adg_max',String(this.state.max/100));
    url.searchParams.set('sort_by',this.state.sort);
    if(this.state.page>1)url.searchParams.set('page',String(this.state.page));
    return url;
  }
  render(write=false) {
    const matched=this.records.map(record=>({record,variants:AdgFilterLogic.variantsMatching(record,this.state,this.rules)})).filter(x=>x.variants.length);
    const pages=Math.max(1,Math.ceil(matched.length/this.config.perPage));
    this.state.page=Math.min(pages,this.state.page);
    if(!this.grid){this.grid=this.element('div',{class:'adg-grid',role:'list','aria-label':this.config.title});this.root.querySelector('[data-adg-results]').prepend(this.grid);}
    const items=matched.slice((this.state.page-1)*this.config.perPage,this.state.page*this.config.perPage);
    this.grid.replaceChildren(...items.map(({record})=>this.cache.get(String(record.id)).node));
    this.root.querySelectorAll('.adg-empty').forEach(e=>e.remove());
    if(!matched.length){const empty=this.element('div',{class:'adg-empty'});empty.append(this.element('h2',{},this.labels.empty),this.element('button',{type:'button',class:'adg-apply','data-adg-custom-clear':''},this.labels.clear));this.grid.after(empty);}
    for(const {record,variants} of items){
      const item=this.cache.get(String(record.id)).node;
      this.root.syncColorVariants(item,variants);
      const pressed=item.querySelector('[data-adg-variant][aria-pressed=true]');
      const selectedId=pressed?new URL(pressed.href).searchParams.get('variant'):null;
      if(!variants.some(v=>String(v.id)===selectedId)) {
        const variant=variants.find(v=>v.available)||variants[0];
        let link=[...item.querySelectorAll('[data-adg-variant]')].find(e=>new URL(e.href).searchParams.get('variant')===String(variant.id));
        if(!link && !record.single)link=this.addVariant(item,variant);
        link?.click();
      }
    }
    this.root.querySelectorAll('.adg-total').forEach(e=>{e.textContent=matched.length+' '+(matched.length===1?this.labels.product:this.labels.products);});
    if(!this.pagination){this.pagination=this.element('nav',{class:'adg-pagination','aria-label':this.labels.pagination});this.root.querySelector('[data-adg-results]').append(this.pagination);}
    this.pagination.replaceChildren();this.pagination.hidden=pages<=1;
    if(pages>1) {
      const candidates=[...new Set([1,this.state.page-1,this.state.page,this.state.page+1,pages])].filter(p=>p>=1&&p<=pages).sort((a,b)=>a-b);
      let previous=0;
      for(const page of candidates){
        if(previous&&page>previous+1)this.pagination.append(this.element('span',{},'…'));
        if(page===this.state.page)this.pagination.append(this.element('span',{'aria-current':'page'},String(page)));
        else {const url=this.getURL();url.searchParams.set('page',String(page));this.pagination.append(this.element('a',{href:url.pathname+url.search,'data-adg-custom-page-link':page},String(page)));}
        previous=page;
      }
    }
    this.buildFields();this.renderChips();
    this.root.enableWishlist();this.root.setView(this.root.dataset.view,false);this.root.setupVariantCarousels();
    if(write){const url=this.getURL();if(url.href!==location.href)history.pushState({},'',url);}
    this.root.querySelector('[data-adg-status]').textContent=matched.length+' '+this.labels.products;
  }
  addVariant(item,v) {
    const link=this.element('a',{class:'adg-variant',href:v.url,role:'button','aria-label':v.title,'aria-pressed':'false','data-adg-variant':''});
    Object.assign(link.dataset,{label:v.title,price:v.money,available:String(v.available),onSale:String(v.onSale),compare:v.compareMoney});
    if(v.image){link.dataset.image=v.image;link.dataset.srcset=v.srcset;const img=this.element('img',{src:v.thumb,alt:v.title,width:'160',height:'200',loading:'lazy'});link.append(img);}else link.append(this.element('span',{class:'adg-variant-text'},v.title));
    item.querySelector('.adg-variant-list')?.append(link);return link;
  }
  renderChips() {
    this.chips.replaceChildren();
    for(const [key,values] of Object.entries(this.state.values))for(const value of values){const b=this.element('button',{type:'button','data-adg-custom-remove':key,'data-value':value},this.label(key)+': '+this.valueLabel(key,value)+' ×');this.chips.append(b);}
    if(this.state.min!==null||this.state.max!==null){const fmt=n=>n===null?'…':new Intl.NumberFormat(this.config.locale,{style:'currency',currency:this.config.currency}).format(n/100);this.chips.append(this.element('button',{type:'button','data-adg-custom-remove':'price'},this.labels.price+': '+fmt(this.state.min)+' – '+fmt(this.state.max)+' ×'));}
    if(this.chips.childElementCount)this.chips.append(this.element('button',{type:'button','data-adg-custom-clear':'',class:'adg-custom-clear'},this.labels.clear));
    this.chips.hidden=!this.chips.childElementCount;
  }
  toggleGroup(details) {
    const previous=this.accordions.get(details);
    const opening=previous ? !previous.opening : !details.open;
    const start=details.getBoundingClientRect().height;
    previous?.animation.cancel();
    if(matchMedia('(prefers-reduced-motion: reduce)').matches || !details.animate) {
      details.open=opening;details.style.removeProperty('overflow');this.accordions.delete(details);return;
    }
    details.open=true;
    const summary=details.querySelector('summary');
    const end=opening ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height+1;
    details.style.overflow='hidden';
    const animation=details.animate([{height:start+'px'},{height:end+'px'}],{duration:260,easing:'cubic-bezier(.25,.1,.25,1)'});
    const entry={animation,opening};
    this.accordions.set(details,entry);
    animation.onfinish=()=>{
      if(this.accordions.get(details)!==entry)return;
      details.open=opening;details.style.removeProperty('overflow');this.accordions.delete(details);
    };
  }
  onClick(event) {
    const target=event.target;
    const summary=target.closest('[data-adg-custom-drawer-key]>summary');
    if(summary){event.preventDefault();this.toggleGroup(summary.parentElement);return;}
    if(target.closest('[data-adg-open-filters]') || target.closest('[data-adg-custom-quick-key]>summary'))this.withData(()=>{});
    if(target.closest('[data-adg-custom-retry]'))this.withData(()=>this.render());
    const page=target.closest('[data-adg-custom-page-link]');
    if(page&&!event.metaKey&&!event.ctrlKey&&!event.shiftKey){event.preventDefault();this.state.page=Number(page.dataset.adgCustomPageLink);this.withData(()=>{this.render(true);this.grid.scrollIntoView({block:'start'});});}
    const remove=target.closest('[data-adg-custom-remove]');
    if(remove){const key=remove.dataset.adgCustomRemove;if(key==='price'){this.state.min=null;this.state.max=null;}else this.state.values[key]=(this.state.values[key]||[]).filter(v=>v!==remove.dataset.value);this.state.page=1;this.withData(()=>this.render(true));}
    if(target.closest('[data-adg-custom-clear]')){this.state.values={};this.state.min=null;this.state.max=null;this.state.page=1;this.withData(()=>this.render(true));}
  }
  stateFromForm(form) {
    const data=new FormData(form),scope=form.dataset.adgCustomScope;
    const state={...this.state,values:{...this.state.values},page:1};
    const keys=scope==='all'?this.config.groups:[scope];
    const readPrice=name=>{const value=data.get(name);return value===null||!String(value).trim()?null:Math.round(Number(value)*100);};
    for(const key of keys) {
      if(key==='price'){state.min=readPrice('adg_min');state.max=readPrice('adg_max');}
      else state.values[key]=data.getAll('adg_'+key);
    }
    return state;
  }
  updateResultCount(form) {
    const button=form.querySelector('[data-adg-result-count]');
    if(!button)return;
    if(this.loadedSort!==this.state.sort){button.disabled=true;button.textContent=this.labels.loading;return;}
    const state=this.stateFromForm(form);
    const count=this.records.filter(record=>AdgFilterLogic.variantsMatching(record,state,this.rules).length>0).length;
    button.disabled=false;
    button.textContent=(count===1?this.labels.viewOne:this.labels.viewOther).replace('__count__',String(count));
  }
  previewForm(event) {
    const form=event.target.closest('.adg-custom-form');
    if(form)this.updateResultCount(form);
  }
  onSubmit(event) {
    if(!event.target.matches('.adg-custom-form'))return;
    event.preventDefault();
    const form=event.target;
    if(!form.reportValidity())return;
    const data=new FormData(form),scope=form.dataset.adgCustomScope;
    const keys=scope==='all'?this.config.groups:[scope];
    const readPrice=name=>{const value=data.get(name);return value===null||!String(value).trim()?null:Math.round(Number(value)*100);};
    const minimum=readPrice('adg_min'),maximum=readPrice('adg_max');
    if(keys.includes('price')&&minimum!==null&&maximum!==null&&minimum>maximum){const input=form.querySelector('[name=adg_min]');input.setCustomValidity(this.labels.priceError);input.reportValidity();input.addEventListener('input',()=>input.setCustomValidity(''),{once:true});return;}
    if(this.loadedSort!==this.state.sort)return this.withData(()=>{});
    this.state=this.stateFromForm(form);
    this.withData(()=>{this.render(true);this.root.dialog?.close();this.root.querySelectorAll('.adg-quick[open]').forEach(d=>{d.open=false;});});
  }
  changeSort(value) {
    this.state.sort=value;this.state.page=1;
    this.withData(()=>this.render(true));
  }
}


class AdgCardImages {
  constructor(root, signal) {
    this.root = root;
    this.signal = signal;
    this.pending = new Map();
    this.registered = new WeakSet();
    this.recovered = new WeakSet();
    root.addEventListener('load', event => {
      const image = event.target;
      if (image.matches?.('.adg-main-image') && image.naturalWidth) this.show(image.closest('[data-adg-card]'));
    }, { capture: true, signal });
    root.addEventListener('error', event => {
      const image = event.target;
      if (image.matches?.('.adg-main-image')) this.recover(image);
    }, { capture: true, signal });
    signal.addEventListener('abort', () => {
      for (const cancel of this.pending.values()) cancel();
      this.pending.clear();
    }, { once: true });
  }
  show(card) {
    if (!card) return;
    const image = card.querySelector('.adg-main-image');
    if (!image.naturalWidth || this.pending.has(image)) return;
    image.hidden = false;
    card.querySelector('[data-adg-missing]').hidden = true;
    card.querySelector('.adg-photo').setAttribute('aria-busy', 'false');
    const note = card.querySelector('[data-adg-general-image]');
    if (note) note.hidden = card.dataset.imageGeneral !== 'true';
  }
  register() {
    this.root.querySelectorAll('.adg-main-image').forEach(image => {
      if (this.registered.has(image)) return;
      this.registered.add(image);
      if (image.complete && image.getAttribute('src')) {
        if (image.naturalWidth) this.show(image.closest('[data-adg-card]'));
        else this.recover(image);
      }
    });
  }
  recover(image) {
    if (this.signal.aborted || this.recovered.has(image) || this.pending.has(image)) return;
    this.recovered.add(image);
    const card = image.closest('[data-adg-card]');
    const variant = card.querySelector('[data-adg-variant][aria-pressed=true]');
    this.load(card, {
      src: variant?.dataset.image || image.getAttribute('src') || card.dataset.fallbackImage,
      srcset: '',
      general: variant ? variant.dataset.imageGeneral === 'true' || !variant.dataset.image : card.dataset.imageGeneral === 'true',
      label: variant?.dataset.label || ''
    });
  }
  load(card, spec) {
    const image = card.querySelector('.adg-main-image');
    const photo = card.querySelector('.adg-photo');
    if (!image || !photo || this.signal.aborted) return;
    this.pending.get(image)?.();
    image.hidden = true;
    card.querySelector('[data-adg-missing]').hidden = true;
    const note = card.querySelector('[data-adg-general-image]');
    if (note) note.hidden = true;
    card.dataset.imageGeneral = String(spec.general);
    if (image.getAttribute('src') === spec.src && image.naturalWidth) {
      this.pending.delete(image);
      this.show(card);
      return;
    }
    const bounds = photo.getBoundingClientRect?.();
    if (spec.src && spec.priority !== 'high' && bounds && bounds.top > innerHeight + 400) {
      image.loading = 'lazy';
      image.srcset = spec.srcset || '';
      image.src = spec.src;
      image.alt = spec.general ? card.dataset.generalLabel : `${card.querySelector('.adg-card-title').textContent.trim()} — ${spec.label}`;
      image.hidden = false;
      if (note) note.hidden = !spec.general;
      photo.setAttribute('aria-busy', 'false');
      this.pending.delete(image);
      return;
    }
    photo.setAttribute('aria-busy', 'true');
    const sources = [];
    if (spec.src) {
      sources.push({ src: spec.src, srcset: spec.srcset, general: spec.general });
      const retry = new URL(spec.src, location.href);
      retry.searchParams.set('width', '640');
      sources.push({ src: retry.href, srcset: '', general: spec.general });
    }
    if (card.dataset.fallbackImage) sources.push({ src: card.dataset.fallbackImage, srcset: '', general: true });
    const seen = new Set();
    const queue = sources.filter(source => {
      const key = new URL(source.src, location.href).href;
      if (seen.has(key)) return false;
      seen.add(key); return true;
    });
    let candidate, timer, cancelled = false;
    const cleanup = () => { clearTimeout(timer); if (candidate) candidate.onload = candidate.onerror = null; };
    const cancel = () => { cancelled = true; cleanup(); };
    this.pending.set(image, cancel);
    const current = () => !cancelled && !this.signal.aborted && this.pending.get(image) === cancel && card.isConnected;
    const next = () => {
      cleanup();
      if (!current()) return;
      const source = queue.shift();
      if (!source) {
        this.pending.delete(image);
        photo.setAttribute('aria-busy', 'false');
        card.querySelector('[data-adg-missing]').hidden = false;
        return;
      }
      candidate = new Image();
      candidate.decoding = 'async';
      candidate.fetchPriority = spec.priority || 'auto';
      candidate.sizes = image.sizes || '50vw';
      candidate.onerror = next;
      candidate.onload = () => {
        if (!current() || !candidate.naturalWidth) return next();
        const loaded = candidate.currentSrc || source.src;
        cleanup();
        card.dataset.imageGeneral = String(source.general);
        image.alt = source.general ? card.dataset.generalLabel : `${card.querySelector('.adg-card-title').textContent.trim()} — ${spec.label}`;
        image.removeAttribute('srcset');
        image.src = loaded;
        image.loading = 'eager';
        image.hidden = false;
        if (note) note.hidden = !source.general;
        photo.setAttribute('aria-busy', 'false');
        this.pending.delete(image);
      };
      timer = setTimeout(next, 12000);
      candidate.srcset = source.srcset || '';
      candidate.src = source.src;
    };
    next();
  }
}

if (!customElements.get('ad-collection-grid')) {
  customElements.define('ad-collection-grid', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.classList.add('is-ready');
      this.querySelectorAll('[data-adg-open-filters],[data-adg-view-controls]').forEach(control => { control.hidden = false; });
      this.dialog = this.querySelector('dialog');
      this.addEventListener('click', event => this.onClick(event), options);
      this.addEventListener('keydown', event => {
        this.onVariantKey(event);
        if (event.key === ' ') {
          const link = event.target.closest('[data-adg-variant]');
          if (link) { event.preventDefault(); link.click(); }
        }
        if (event.key === 'Escape') this.querySelectorAll('.adg-quick[open]').forEach(details => { details.open = false; details.querySelector('summary').focus(); });
      }, options);
      this.addEventListener('change', event => { if (event.target.matches('[data-adg-sort]')) event.target.form.requestSubmit(); }, options);
      this.addEventListener('input', event => { if (event.target.matches('[data-adg-price]')) event.target.form.querySelectorAll('[data-adg-price]').forEach(input => input.setCustomValidity('')); }, options);
      this.addEventListener('submit', event => this.onSubmit(event), options);
      this.cardImages = new AdgCardImages(this, this.abort.signal);
      document.addEventListener('click', event => this.querySelectorAll('.adg-quick[open]').forEach(details => { if (!details.contains(event.target)) details.open = false; }), options);
      this.dialog?.addEventListener('close', () => this.opener?.focus(), options);
      try { this.setView(localStorage.getItem(this.dataset.storageKey) === 'list' ? 'list' : 'grid', false); } catch (_) { this.setView('grid', false); }
      matchMedia('(max-width:749px)').addEventListener('change', () => {
        try { this.setView(localStorage.getItem(this.dataset.storageKey) === 'list' ? 'list' : 'grid', false); } catch (_) { this.setView('grid', false); }
      }, options);
      this.carouselTracks = new WeakSet();
      this.colorChoices = new WeakMap();
      this.setupVariantCarousels();
      this.carouselResize = new ResizeObserver(() => this.setupVariantCarousels());
      this.carouselResize.observe(this);
      this.enableWishlist();
      if (this.dataset.customFilters === 'true') this.customFilters = new AdgCustomFilters(this);
    }
    disconnectedCallback() {
      this.dialog?.close();
      this.customFilters = null;
      this.carouselResize?.disconnect();
      this.abort?.abort();
      this.abort = null;
    }
    enableWishlist() {
      if (!this.querySelector('[data-adg-theme-wishlist]')) return;
      customElements.whenDefined('wishlist-button').then(() => {
        if (!this.isConnected || !document.querySelector('wishlist-container')) return;
        this.querySelectorAll('[data-adg-theme-wishlist]').forEach(wishlist => { wishlist.hidden = false; });
      });
    }
    setView(view, persist = true) {
      view = 'grid';
      this.dataset.view = view;
      this.querySelectorAll('[data-adg-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.adgView === view)));
      this.querySelectorAll('.adg-main-image').forEach(image => { image.sizes = view === 'list' ? '(min-width: 750px) 280px, 38vw' : '(min-width: 1200px) 25vw, (min-width: 750px) 33vw, 50vw'; });
      if (persist) { try { localStorage.setItem(this.dataset.storageKey, view); } catch (_) {} }
    }
    missingImage(card) {
      card.querySelector('.adg-main-image').hidden = true;
      card.querySelector('[data-adg-missing]').hidden = false;
    }
    syncColorVariants(card,matching) {
      card=card.matches('[data-adg-card]')?card:card.querySelector('[data-adg-card]');
      if(!card)return;
      const track=card.querySelector('.adg-variant-list');
      if(!track)return;
      let choices=this.colorChoices.get(card);
      if(!choices){choices=[...track.querySelectorAll('[data-adg-variant]')];this.colorChoices.set(card,choices);}
      const current=track.querySelector('[data-adg-variant][aria-pressed=true]');
      const key=link=>AdgFilterLogic.normalize(link.dataset.color || '');
      const currentKey=current?key(current):null;
      const allowed=matching?new Set(matching.map(v=>String(v.id))):null;
      const groups=new Map();
      for(const choice of choices) {
        const id=new URL(choice.href).searchParams.get('variant');
        if(allowed&&!allowed.has(id))continue;
        const color=key(choice);
        if(!groups.has(color))groups.set(color,[]);
        groups.get(color).push(choice);
      }
      const representatives=[];
      let active;
      for(const [color,variants] of groups) {
        const available=variants.filter(v=>v.dataset.available==='true');
        const candidates=available.length?available:variants;
        const representative=candidates.includes(current)?current:candidates[0];
        representatives.push(representative);
        if(color===currentKey)active=representative;
      }
      for(const choice of choices){choice.hidden=false;choice.setAttribute('aria-pressed',String(choice===active));}
      track.replaceChildren(...representatives);
      if(active&&active!==current)active.click();
    }
    setupVariantCarousels() {
      this.cardImages?.register();
      this.querySelectorAll('[data-adg-variant-carousel]').forEach(carousel => {
        const card=carousel.closest('[data-adg-card]');
        if(!this.colorChoices.has(card))this.syncColorVariants(card);
        const track=carousel.querySelector('.adg-variant-list');
        if(!track)return;
        const fresh=!this.carouselTracks.has(track);
        if(fresh) {
          this.carouselTracks.add(track);
          track.addEventListener('scroll',()=>this.updateVariantArrows(carousel),{passive:true,signal:this.abort.signal});
          track.addEventListener('focusin',event=>{const variant=event.target.closest('[data-adg-variant]');if(variant)this.revealVariant(variant,'auto');},{signal:this.abort.signal});
        }
        const visible=matchMedia('(max-width:749px)').matches?3:5;
        track.classList.toggle('is-short',track.querySelectorAll('[data-adg-variant]').length<=visible);
        carousel.querySelectorAll('.adg-variant-arrow').forEach(button=>{button.hidden=false;});
        if(fresh){const selected=track.querySelector('[aria-pressed=true]');if(selected)this.revealVariant(selected,'auto');}
        this.updateVariantArrows(carousel);
      });
    }
    updateVariantArrows(carousel) {
      const track=carousel.querySelector('.adg-variant-list');
      const maximum=Math.max(0,track.scrollWidth-track.clientWidth);
      carousel.querySelector('[data-adg-variant-prev]').disabled=track.scrollLeft<=2;
      carousel.querySelector('[data-adg-variant-next]').disabled=track.scrollLeft>=maximum-2;
    }
    revealVariant(variant,behavior) {
      const track=variant.closest('.adg-variant-list');
      if(!track)return;
      const item=variant.getBoundingClientRect(),frame=track.getBoundingClientRect();
      let change=0;
      if(item.left<frame.left+4)change=item.left-frame.left-4;
      else if(item.right>frame.right-4)change=item.right-frame.right+4;
      if(change)track.scrollTo({left:track.scrollLeft+change,behavior:behavior || (matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth')});
    }
    moveVariants(button) {
      const carousel=button.closest('[data-adg-variant-carousel]');
      const track=carousel.querySelector('.adg-variant-list');
      const item=track.querySelector('[data-adg-variant]');
      if(!item)return;
      const visible=matchMedia('(max-width:749px)').matches?3:5;
      const step=(item.getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap || 0))*visible;
      const direction=button.hasAttribute('data-adg-variant-next')?1:-1;
      track.scrollTo({left:track.scrollLeft+direction*step,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
    }
    onVariantKey(event) {
      const variant=event.target.closest('[data-adg-variant]');
      if(!variant || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
      const variants=[...variant.parentElement.querySelectorAll('[data-adg-variant]')];
      const current=variants.indexOf(variant);
      const index=event.key==='Home'?0:event.key==='End'?variants.length-1:Math.max(0,Math.min(variants.length-1,current+(event.key==='ArrowRight'?1:-1)));
      event.preventDefault();variants[index].focus({preventScroll:true});this.revealVariant(variants[index]);
    }
    loadVariantImage(card, variant, priority) {
      this.cardImages.load(card, {
        src: variant.dataset.image || card.dataset.fallbackImage,
        srcset: variant.dataset.srcset || '',
        general: variant.dataset.imageGeneral === 'true' || !variant.dataset.image,
        label: variant.dataset.label,
        priority: priority || 'auto'
      });
    }
    onClick(event) {
      const arrow=event.target.closest('[data-adg-variant-prev],[data-adg-variant-next]');
      if(arrow){event.preventDefault();this.moveVariants(arrow);return;}
      const variant = event.target.closest('[data-adg-variant]');
      if (variant && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
        event.preventDefault();
        const card = variant.closest('[data-adg-card]');
        card.querySelectorAll('[data-adg-variant]').forEach(link => link.setAttribute('aria-pressed', String(link === variant)));
        this.revealVariant(variant);
        card.querySelectorAll('[data-adg-product-link]').forEach(link => { link.href = variant.href; });
        card.querySelector('[data-adg-price-current]').textContent = variant.dataset.price;
        const compare = card.querySelector('[data-adg-compare]');
        compare.hidden = variant.dataset.onSale !== 'true';
        compare.textContent = variant.dataset.compare;
        card.querySelector('[data-adg-sold-out]').hidden = variant.dataset.available === 'true';
        card.querySelector('[data-adg-current-variant]').textContent = variant.dataset.label;
        this.loadVariantImage(card, variant, event.isTrusted ? 'high' : 'auto');
        this.querySelector('[data-adg-status]').textContent = `${variant.dataset.label} — ${variant.dataset.price}`;
      }
      const view = event.target.closest('[data-adg-view]');
      if (view) this.setView(view.dataset.adgView);
      const opener = event.target.closest('[data-adg-open-filters]');
      if (opener && this.dialog) { this.opener = opener; this.dialog.showModal(); }
      if (event.target.closest('[data-adg-close-filters]')) this.dialog?.close();
      if (event.target === this.dialog) {
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }
    }
    onSubmit(event) {
      if (this.customFilters && event.target.matches('.adg-sort')) { event.preventDefault(); this.customFilters.changeSort(event.target.querySelector('[data-adg-sort]').value); return; }
      if (!event.target.matches('.adg-get-form')) return;
      event.preventDefault();
      const form = event.target;
      const minimum = form.querySelector('[data-adg-price=min]');
      const maximum = form.querySelector('[data-adg-price=max]');
      if (minimum?.value && maximum?.value && Number(minimum.value) > Number(maximum.value)) {
        minimum.setCustomValidity(this.dataset.priceError);
        minimum.reportValidity();
        return;
      }
      if (!form.reportValidity()) return;
      const url = new URL(form.action, location.href);
      url.search = '';
      for (const [name, value] of new FormData(form)) { if (String(value).trim()) url.searchParams.append(name, value); }
      location.assign(url.href);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["addiesdive-colecoes-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('addies-collection-banners')) {
    customElements.define('addies-collection-banners', class extends HTMLElement {
      connectedCallback() {
        this.onGuideClick = this.onGuideClick || ((event) => {
          const link = event.target.closest('[data-ad-next]');
          if (!link || !this.contains(link) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const id = link.getAttribute('href').slice(1);
          const target = document.getElementById(id);
          if (!target || !this.contains(target)) return;
          event.preventDefault();
          const offset = Number(this.dataset.scrollOffset) || 0;
          const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset);
          const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
          window.scrollTo({ top, behavior });
          target.querySelector('.ad-collections__title')?.focus({ preventScroll: true });
        });
        this.onBlockSelect = this.onBlockSelect || ((event) => {
          const banner = event.target.closest('[data-ad-banner]');
          if (banner && this.contains(banner)) banner.scrollIntoView({ behavior: 'instant', block: 'start' });
        });
        this.addEventListener('click', this.onGuideClick);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onGuideClick);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["addiesdive-complementares"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ad-complements-cards-v11')) {
  customElements.define('ad-complements-cards-v11', class extends HTMLElement {
    connectedCallback() {
      if (this.listeners) return;
      this.listeners = new AbortController();
      const signal = this.listeners.signal;
      this.track = this.querySelector('.ad-complements__track');
      this.navigation = this.querySelector('.ad-complements__navigation');
      this.footer = this.querySelector('[data-purchase-footer]');
      this.message = this.querySelector('[data-purchase-message]');
      this.cartButton = this.querySelector('[data-open-cart]');
      this.cards = Array.from(this.querySelectorAll('[data-purchase-card]'));
      this.dataset.enhanced = 'true';
      if (this.footer) this.footer.hidden = false;
      this.cards.forEach(card => {
        card.querySelectorAll('[data-pick-variant]').forEach(input => {
          input.addEventListener('change', () => {
            this.updateCards();
            const message = card.querySelector('[data-card-message]');
            if (message) message.textContent = '';
          }, {signal});
        });
        card.querySelector('[data-add-card]')?.addEventListener('click', () => this.addCard(card), {signal});
      });
      this.cartButton?.addEventListener('click', () => this.viewCart(), {signal});
      this.navButtons = Array.from(this.querySelectorAll('[data-direction]'));
      this.counter = this.querySelector('.ad-complements__counter');
      this.updateNavigation = () => {
        if (!this.track || !this.navigation) return;
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const left = this.track.scrollLeft;
        this.navigation.hidden = max <= 2;
        this.navButtons.forEach(button => { button.disabled = button.dataset.direction === '-1' ? left <= 2 : left >= max - 2; });
        const cards = Array.from(this.track.children);
        if (!cards.length || !this.counter) return;
        const edge = this.track.getBoundingClientRect().left;
        const index = cards.reduce((closest, card, i) => Math.abs(card.getBoundingClientRect().left - edge) < Math.abs(cards[closest].getBoundingClientRect().left - edge) ? i : closest, 0);
        this.counter.textContent = `${String(index + 1).padStart(2, '0')} / ${String(cards.length).padStart(2, '0')}`;
      };
      this.navButtons.forEach(button => button.addEventListener('click', () => {
        const first = this.track?.firstElementChild;
        if (!first) return;
        this.track.scrollBy({left: Number(button.dataset.direction) * (first.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 0)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }, {signal}));
      this.track?.addEventListener('scroll', this.updateNavigation, {passive: true, signal});
      if (this.track) { this.observer = new ResizeObserver(this.updateNavigation); this.observer.observe(this.track); }
      this.updateCards();
      this.updateNavigation();
    }
    getItem(card) {
      const option = card.querySelector('[data-pick-variant]:checked');
      const hasOptions = !!card.querySelector('[data-pick-variant]');
      const id = Number(hasOptions ? option?.value : card.dataset.variantId);
      return {id, quantity: 1, valid: !!card.querySelector('[data-add-card]') && Number.isSafeInteger(id) && id > 0 && (!hasOptions || (!!option && !option.disabled && option.dataset.eligible === 'true'))};
    }
    updateCards() {
      if (this.busy) return;
      this.cards.forEach(card => {
        card.querySelectorAll('[data-pick-variant]').forEach(radio => { radio.disabled = radio.dataset.eligible !== 'true'; });
        const button = card.querySelector('[data-add-card]');
        if (button) button.disabled = !this.getItem(card).valid;
        const option = card.querySelector('[data-pick-variant]:checked');
        if (!option) return;
        card.querySelector('.ad-complements__price').textContent = option.dataset.money;
        const compare = card.querySelector('.ad-complements__old-price');
        if (compare) { compare.textContent = option.dataset.compareMoney; compare.hidden = option.dataset.onSale !== 'true'; }
        const label = card.querySelector('[data-current-variant]');
        if (label) label.textContent = option.dataset.label;
        const image = card.querySelector('.ad-complements__image');
        const missing = card.querySelector('[data-missing-image]');
        if (option.dataset.image) {
          image.srcset = option.dataset.srcset;
          image.src = option.dataset.image;
          image.alt = option.dataset.label;
          image.hidden = false;
          if (missing) missing.hidden = true;
        } else {
          image.hidden = true;
          image.removeAttribute('src');
          image.removeAttribute('srcset');
          if (missing) missing.hidden = false;
        }
        card.querySelectorAll('[data-product-link]').forEach(link => { if (option.dataset.url) link.href = option.dataset.url; });
      });
    }
    applyCartSections(sections) {
      if (typeof sections?.['offcanvas-cart'] !== 'string') return false;
      const doc = new DOMParser().parseFromString(sections['offcanvas-cart'], 'text/html');
      const nextCart = doc.querySelector('cart-container');
      const currentCart = document.querySelector('#offcanvas-cart cart-container');
      if (!nextCart || !currentCart) return false;
      currentCart.replaceWith(nextCart);
      if (typeof sections['cart-count-badge'] === 'string') {
        const badgeDoc = new DOMParser().parseFromString(sections['cart-count-badge'], 'text/html');
        const nextBadge = badgeDoc.querySelector('.cart-count-badge');
        if (nextBadge) document.querySelectorAll('.cart-count-badge').forEach(badge => badge.replaceWith(nextBadge.cloneNode(true)));
      }
      window.dispatchEvent(new CustomEvent('ks.cart.reloaded'));
      return true;
    }
    showCart(trigger) {
      const drawer = document.querySelector('#offcanvas-cart');
      const Offcanvas = window.bootstrap?.Offcanvas;
      if (!drawer || !Offcanvas) throw new Error(this.dataset.drawerError);
      if (!this.isConnected) return;
      document.querySelectorAll('.offcanvas.show').forEach(panel => {
        if (panel !== drawer) Offcanvas.getOrCreateInstance(panel).hide();
      });
      if (!drawer.classList.contains('show') && !drawer.classList.contains('showing')) {
        drawer.addEventListener('hidden.bs.offcanvas', () => {
          if (trigger?.isConnected) trigger.focus({preventScroll: true});
        }, {once: true, signal: this.listeners.signal});
      }
      Offcanvas.getOrCreateInstance(drawer).show(trigger);
    }
    async openCart(sections, trigger) {
      if (!this.applyCartSections(sections)) {
        const url = new URL(window.location.href);
        url.searchParams.set('sections', 'cart-count-badge,offcanvas-cart');
        const response = await fetch(url.toString(), {credentials: 'same-origin', headers: {'Accept': 'application/json'}});
        if (!response.ok || !this.applyCartSections(await response.json())) throw new Error(this.dataset.drawerError);
      }
      this.showCart(trigger);
    }
    async viewCart() {
      if (this.busy || this.cartOpening) return;
      this.cartOpening = true;
      this.cartButton.disabled = true;
      this.cartButton.setAttribute('aria-busy', 'true');
      try {
        this.showCart(this.cartButton);
        this.message.textContent = '';
        this.updateCards();
      } catch (error) {
        if (this.isConnected) this.message.textContent = error.message || this.dataset.drawerError;
      } finally {
        this.cartOpening = false;
        this.cartButton.disabled = false;
        this.cartButton.removeAttribute('aria-busy');
      }
    }
    async addCard(card) {
      if (this.busy || this.cartOpening) return;
      const item = this.getItem(card);
      if (!item.valid) { this.updateCards(); return; }
      const button = card.querySelector('[data-add-card]');
      const message = card.querySelector('[data-card-message]');
      this.busy = true;
      const controls = Array.from(this.querySelectorAll('[data-pick-variant], [data-add-card], [data-open-cart]'));
      const priorDisabled = controls.map(control => control.disabled);
      controls.forEach(control => { control.disabled = true; });
      button.setAttribute('aria-busy', 'true');
      button.textContent = this.dataset.loadingText;
      message.textContent = '';
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST', credentials: 'same-origin',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items: [{id: item.id, quantity: 1}], sections: ['cart-count-badge', 'offcanvas-cart'], sections_url: window.location.pathname + window.location.search})
        });
        let data;
        try { data = await response.json(); } catch { throw new Error(this.dataset.errorText); }
        if (!response.ok) {
          const description = typeof data.description === 'string' ? data.description : '';
          throw new Error([description, this.dataset.errorText].filter(Boolean).join(' '));
        }
        if (!Array.isArray(data.items) || !data.items.some(line => Number(line.variant_id || line.id) === item.id)) throw new Error(this.dataset.errorText);
        if (this.isConnected) {
          message.textContent = '';
          window.dispatchEvent(new CustomEvent('ks.cart.added', {detail: data}));
          try {
            await this.openCart(data.sections, button);
          } catch (error) {
            message.textContent = error.message || this.dataset.drawerError;
          }
        }
      } catch (error) {
        if (this.isConnected) message.textContent = error.message || this.dataset.errorText;
      } finally {
        this.busy = false;
        controls.forEach((control, i) => { control.disabled = priorDisabled[i]; });
        button.textContent = this.dataset.addText;
        button.removeAttribute('aria-busy');
        if (this.isConnected) this.updateCards();
      }
    }
    disconnectedCallback() {
      this.listeners?.abort();
      this.observer?.disconnect();
      this.listeners = null;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["addiesdive-ele-ela"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('addies-audience-navigation')) {
  customElements.define('addies-audience-navigation', class extends HTMLElement {
    connectedCallback() {
      cancelAnimationFrame(this.mountFrame);
      this.mountFrame = requestAnimationFrame(() => { if (this.isConnected) this.initialize(); });
    }
    initialize() {
      this.controller?.abort();
      this.barObserver?.disconnect();
      cancelAnimationFrame(this.barFrame);
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('click', event => {
        const track = event.target.closest('.ad-audience__track');
        if (track && this.suppressedTrack === track && Date.now() < this.suppressUntil) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { ...options, capture: true });
      this.addEventListener('click', event => {
        const hero = event.target.closest('.ad-audience__hero');
        if (!hero) return;
        if (event.target.closest('[data-audience-open]')) this.open(hero, true);
        if (event.target.closest('[data-audience-close]')) this.close(hero);
      }, options);
      this.addEventListener('keydown', event => {
        const hero = event.target.closest('.ad-audience__hero');
        if (hero && event.key === 'Escape' && hero.dataset.open === 'true') {
          event.preventDefault();
          this.close(hero);
          return;
        }
        const track = event.target.closest('.ad-audience__track');
        if (!track || event.altKey || event.ctrlKey || event.metaKey || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const step = track.children.length > 1 ? track.children[1].offsetLeft - track.children[0].offsetLeft : track.clientWidth;
        const left = event.key === 'Home' ? 0 : event.key === 'End' ? track.scrollWidth : track.scrollLeft + (event.key === 'ArrowRight' ? step : -step);
        track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, options);
      this.barObserver = new ResizeObserver(() => this.scheduleBars());
      this.querySelectorAll('.ad-audience__track').forEach(track => {
        this.barObserver.observe(track);
        this.connectBar(track, options);
        track.addEventListener('scroll', () => {
          if(track.scrollTop) track.scrollTop=0;
          this.scheduleBars();
        }, { ...options, passive:true });
        let gesture;
        track.addEventListener('dragstart', event => event.preventDefault(), options);
        track.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          gesture = { id: event.pointerId, start: event.clientX, left: track.scrollLeft, moved: false };
        }, options);
        track.addEventListener('pointermove', event => {
          if (!gesture || gesture.id !== event.pointerId) return;
          const distance = event.clientX - gesture.start;
          if (!gesture.moved && Math.abs(distance) < 8) return;
          if (!gesture.moved) {
            gesture.moved = true;
            track.dataset.dragging = 'true';
            track.setPointerCapture(event.pointerId);
          }
          event.preventDefault();
          track.scrollLeft = gesture.left - distance;
        }, options);
        const finish = event => {
          if (!gesture || gesture.id !== event.pointerId) return;
          if (gesture.moved) {
            this.suppressedTrack = track;
            this.suppressUntil = Date.now() + 250;
          }
          gesture = null;
          delete track.dataset.dragging;
          if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
        };
        track.addEventListener('pointerup', finish, options);
        track.addEventListener('pointercancel', finish, options);
        track.addEventListener('lostpointercapture', finish, options);
        track.addEventListener('pointerleave', event => { if (gesture && !gesture.moved) gesture = null; }, options);
      });
      this.scheduleBars();
      document.addEventListener('shopify:block:select', event => {
        const card = [...this.querySelectorAll('[data-card-id]')].find(element => element.dataset.cardId === event.detail?.blockId);
        const hero = card?.closest('.ad-audience__hero');
        if (!hero) return;
        this.open(hero, false);
        const track = hero.querySelector('.ad-audience__track');
        track.scrollTo({ left: card.offsetLeft - track.children[0].offsetLeft, behavior: 'instant' });
      }, options);
    }
    connectBar(track, options) {
      const bar = track.parentElement.querySelector('[data-audience-scrollbar]');
      if (!bar) return;
      let drag;
      const move = event => {
        if (!drag || drag.id !== event.pointerId) return;
        const rect = bar.getBoundingClientRect();
        const thumbWidth = bar.querySelector('[data-audience-scroll-thumb]').getBoundingClientRect().width;
        const travel = rect.width - thumbWidth;
        if (travel <= 0) return;
        const fraction = Math.max(0, Math.min(1, (event.clientX - rect.left - drag.grip) / travel));
        const rtl = getComputedStyle(track).direction === 'rtl';
        const maximum = track.scrollWidth - track.clientWidth;
        track.scrollTo({ left: rtl ? -(1 - fraction) * maximum : fraction * maximum, behavior:'instant' });
        this.updateBar(track);
      };
      bar.addEventListener('pointerdown', event => {
        if (event.isPrimary === false || event.button !== 0) return;
        event.preventDefault();
        bar.focus({ preventScroll:true });
        const thumb = bar.querySelector('[data-audience-scroll-thumb]').getBoundingClientRect();
        const inside = event.clientX >= thumb.left && event.clientX <= thumb.right;
        drag = { id:event.pointerId, grip:inside ? event.clientX - thumb.left : thumb.width / 2 };
        bar.setAttribute('data-active',''); track.setAttribute('data-bar-drag','');
        bar.setPointerCapture(event.pointerId);
        move(event);
      }, options);
      bar.addEventListener('pointermove', move, options);
      const finish = event => {
        if (!drag || drag.id !== event.pointerId) return;
        drag = null;
        bar.removeAttribute('data-active'); track.removeAttribute('data-bar-drag');
        if (bar.hasPointerCapture(event.pointerId)) bar.releasePointerCapture(event.pointerId);
        this.scheduleBars();
      };
      bar.addEventListener('pointerup', finish, options);
      bar.addEventListener('pointercancel', finish, options);
      bar.addEventListener('lostpointercapture', finish, options);
      bar.addEventListener('keydown', event => {
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        if (!['ArrowLeft','ArrowRight','Home','End','PageUp','PageDown',' '].includes(event.key)) return;
        event.preventDefault();
        const maximum = track.scrollWidth - track.clientWidth;
        const rtl = getComputedStyle(track).direction === 'rtl';
        const step = track.children.length > 1 ? track.children[1].offsetLeft - track.children[0].offsetLeft : track.clientWidth;
        let left;
        if (event.key === 'Home') left = 0;
        else if (event.key === 'End') left = rtl ? -maximum : maximum;
        else {
          const forward = event.key === 'ArrowRight' || event.key === 'PageDown' || (event.key === ' ' && !event.shiftKey);
          const distance = event.key.startsWith('Arrow') ? Math.abs(step) : track.clientWidth;
          left = track.scrollLeft + (forward ? distance : -distance);
          if (rtl && !event.key.startsWith('Arrow')) left = track.scrollLeft - (forward ? distance : -distance);
        }
        track.scrollTo({ left, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, options);
    }
    scheduleBars() {
      cancelAnimationFrame(this.barFrame);
      this.barFrame = requestAnimationFrame(() => {
        if (!this.isConnected) return;
        this.querySelectorAll('.ad-audience__track').forEach(track => this.updateBar(track));
      });
    }
    updateBar(track) {
      const bar = track.parentElement.querySelector('[data-audience-scrollbar]');
      if (!bar) return;
      const viewport = track.clientWidth;
      const maximum = track.scrollWidth - viewport;
      const visible = viewport > 0 && maximum > 1 && !track.closest('.ad-audience__panel').hidden;
      bar.hidden = !visible;
      if (!visible) return;
      const ratio = Math.min(1, viewport / track.scrollWidth);
      const position = Math.max(0, Math.min(maximum, Math.abs(track.scrollLeft))) / maximum;
      const rtl = getComputedStyle(track).direction === 'rtl';
      bar.setAttribute('aria-valuenow', String(Math.round(position * 100)));
      bar.style.setProperty('--ad-bar-thumb', `${ratio * 100}%`);
      bar.style.setProperty('--ad-bar-offset', `${(rtl ? 1 - position : position) * bar.clientWidth * (1 - ratio)}px`);
    }
    open(hero, focus) {
      const panel = hero.querySelector('.ad-audience__panel');
      if (!panel) return;
      panel.hidden = false;
      hero.dataset.open = 'true';
      this.scheduleBars();
      hero.querySelector('[data-audience-open]').setAttribute('aria-expanded', 'true');
      if (focus) hero.querySelector('[data-audience-close]').focus({ preventScroll: true });
    }
    close(hero) {
      hero.dataset.open = 'false';
      this.scheduleBars();
      hero.querySelector('.ad-audience__panel').hidden = true;
      const trigger = hero.querySelector('[data-audience-open]');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus({ preventScroll: true });
    }
    disconnectedCallback() { cancelAnimationFrame(this.mountFrame); this.controller?.abort(); this.barObserver?.disconnect(); cancelAnimationFrame(this.barFrame); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["addiesdive-home-intro"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('addies-home-intro')) {
    class AddiesHomeIntro extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.header = document.getElementById('header-group');
        this.backdrop = this.querySelector('.ad-home-intro__backdrop');
        this.copy = this.querySelector('.ad-home-intro__copy');
        this.track = this.querySelector('.ad-home-intro__track');
        this.cards = [...this.querySelectorAll('.ad-home-intro__card')];
        this.video = this.querySelector('video');
        this.videoButton = this.querySelector('.ad-home-intro__video-control');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = matchMedia('(max-width:749px)');
        this.dataset.cardsReady = String(!this.motion.matches && this.dataset.animation === 'true');
        this.index = 0;
        this.userPaused = false;
        this.lastScroll = window.scrollY;
        this.pauseKey = `addies-home-cards-once-v2:${this.id}`;
        AddiesHomeIntro.seen ||= new Set();
        this.entranceStarted = AddiesHomeIntro.seen.has(this.pauseKey);
        try { this.entranceStarted ||= sessionStorage.getItem(this.pauseKey) === '1'; } catch {}
        this.entranceComplete = this.entranceStarted;
        this.pauseUsed = this.entranceStarted;
        this.dataset.entranceComplete = String(this.entranceComplete);
        this.dataset.cardsRevealed = String(this.entranceStarted);
        const atCeiling = () => this.scrollHeld && window.scrollY >= this.heldScroll - 1;
        window.addEventListener('wheel', event => {
          if (!atCeiling() || event.ctrlKey || event.defaultPrevented) return;
          if (event.deltaY > 0 && Math.abs(event.deltaY) > Math.abs(event.deltaX)) event.preventDefault();
        }, { ...options, passive:false });
        window.addEventListener('touchstart', event => {
          this.touchPoint = event.touches.length === 1 ? { x:event.touches[0].clientX, y:event.touches[0].clientY } : null;
        }, { ...options, passive:true });
        window.addEventListener('touchmove', event => {
          const previous = this.touchPoint;
          const touch = event.touches.length === 1 ? event.touches[0] : null;
          this.touchPoint = touch ? { x:touch.clientX, y:touch.clientY } : null;
          if (!previous || !touch || !atCeiling() || event.defaultPrevented) return;
          const down = previous.y - touch.clientY;
          const sideways = previous.x - touch.clientX;
          if (down > 0 && Math.abs(down) > Math.abs(sideways)) event.preventDefault();
        }, { ...options, passive:false });
        const clearTouch = () => { this.touchPoint = null; };
        window.addEventListener('touchend', clearTouch, { ...options, passive:true });
        window.addEventListener('touchcancel', clearTouch, { ...options, passive:true });
        window.addEventListener('keydown', event => {
          if (!atCeiling() || event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey) return;
          if (event.target.closest('input,textarea,select,button,[contenteditable]:not([contenteditable=false])')) return;
          const down = ['ArrowDown','PageDown','End'].includes(event.key) || (event.key === ' ' && !event.shiftKey);
          if (down) event.preventDefault();
        }, options);
        window.addEventListener('scroll', () => this.schedule(), { ...options, passive: true });
        window.addEventListener('resize', () => this.resize(), options);
        this.motion.addEventListener('change', () => { this.schedule(); this.updateVideo(); }, options);
        this.mobile.addEventListener('change', () => this.resize(), options);
        document.addEventListener('visibilitychange', () => this.updateVideo(), options);
        if (this.track) {
          this.track.addEventListener('scroll', () => {
            cancelAnimationFrame(this.trackFrame);
            this.trackFrame = requestAnimationFrame(() => this.updateControls());
          }, { ...options, passive: true });
          this.track.addEventListener('keydown', event => {
            if (!this.mobile.matches || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
            event.preventDefault();
            let i = this.index + (event.key === 'ArrowRight' ? 1 : -1);
            if (event.key === 'Home') i = 0;
            if (event.key === 'End') i = this.cards.length - 1;
            this.goTo(i);
          }, options);
        }
        this.videoButton?.addEventListener('click', () => { this.userPaused = !this.userPaused; this.updateVideo(); }, options);
        this.resizeObserver = new ResizeObserver(() => this.resize());
        if (this.header) this.resizeObserver.observe(this.header);
        if (this.track) this.resizeObserver.observe(this.track);
        this.visibilityObserver = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.updateVideo();
        });
        this.visibilityObserver.observe(this);
        this.resize();
      }
      resize() {
        this.style.setProperty('--ad-header', `${this.header?.getBoundingClientRect().height || 0}px`);
        this.schedule();
        this.updateControls();
      }
      schedule() {
        if (this.pending) return;
        this.pending = requestAnimationFrame(() => { this.pending = null; this.render(); });
      }
      render() {
        const scroll = window.scrollY;
        const cardsArea = this.querySelector('.ad-home-intro__cards');
        const stop = cardsArea ? scroll + cardsArea.getBoundingClientRect().top : Infinity;
        if (this.scrollHeld) {
          this.heldScroll = stop;
          if (scroll > this.heldScroll + 1) window.scrollTo({ top:this.heldScroll, behavior:'instant' });
        } else if (!this.pauseUsed && !this.entranceComplete && !this.motion.matches && this.dataset.animation === 'true' && this.cards.length && this.lastScroll < stop && scroll >= stop && scroll > this.lastScroll) {
          this.pauseUsed = true;
          this.scrollHeld = true;
          this.heldScroll = stop;
          window.scrollTo({ top:stop, behavior:'instant' });
        }
        this.lastScroll = Math.min(scroll, this.scrollHeld ? this.heldScroll : Infinity);
        const headerHeight = this.header?.getBoundingClientRect().height || 0;
        const rect = this.querySelector('.ad-home-intro__hero').getBoundingClientRect();
        const height = this.backdrop.getBoundingClientRect().height;
        const p = Math.max(0, Math.min(1, (headerHeight - rect.top) / height));
        const animate = !this.motion.matches && this.dataset.animation === 'true';
        const amount = animate ? p : 0;
        this.style.setProperty('--ad-active-blur', `calc(var(--ad-blur) * ${amount})`);
        this.style.setProperty('--ad-scale', String(1 + amount * .045));
        this.style.setProperty('--ad-dark', String(animate ? p : 0));
        this.style.setProperty('--ad-copy-opacity', String(animate ? 1 - p : 1));
        this.style.setProperty('--ad-copy-y', `${-amount * 40}px`);
        this.dataset.cardsReady = String(animate && !this.entranceComplete);
        if (!animate) {
          this.finishEntrance(this.entranceStarted);
          this.dataset.cardsRevealed = 'true';
        } else if (!this.entranceStarted && this.cards.length && p > .12) {
          this.startEntrance();
        }
        if (this.entranceStarted) this.dataset.cardsRevealed = 'true';
        this.copy.inert = animate && p > .98;
        this.updateVideo();
      }
      startEntrance() {
        this.entranceStarted = true;
        this.dataset.cardsRevealed = 'true';
        AddiesHomeIntro.seen.add(this.pauseKey);
        try { sessionStorage.setItem(this.pauseKey, '1'); } catch {}
        const seconds = value => value.trim().endsWith('ms') ? parseFloat(value) / 1000 : parseFloat(value) || 0;
        const duration = this.cards.reduce((maximum, card) => {
          const style = getComputedStyle(card);
          const durations = style.animationDuration.split(',').map(seconds);
          const delays = style.animationDelay.split(',').map(seconds);
          return Math.max(maximum, ...durations.map((time, index) => time + delays[index % delays.length]));
        }, 0) * 1000;
        if (duration <= 0) this.finishEntrance(true);
        else this.releaseTimer = setTimeout(() => this.finishEntrance(true), duration + 80);
      }
      finishEntrance(permanent) {
        clearTimeout(this.releaseTimer);
        this.scrollHeld = false;
        if (permanent) {
          this.entranceStarted = true;
          this.entranceComplete = true;
          this.pauseUsed = true;
          this.dataset.entranceComplete = 'true';
          this.dataset.cardsReady = 'false';
          this.dataset.cardsRevealed = 'true';
        }
      }
      goTo(index) {
        if (!this.track || !this.mobile.matches) return;
        const i = Math.max(0, Math.min(this.cards.length - 1, index));
        this.track.scrollTo({ left: this.cards[i].offsetLeft - this.cards[0].offsetLeft, behavior: this.motion.matches ? 'instant' : 'smooth' });
      }
      updateControls() {
        if (!this.track || !this.cards.length) return;
        const left = this.track.scrollLeft;
        this.index = this.cards.reduce((best, card, i) => Math.abs(card.offsetLeft - this.cards[0].offsetLeft - left) < Math.abs(this.cards[best].offsetLeft - this.cards[0].offsetLeft - left) ? i : best, 0);
      }
      updateVideo() {
        if (!this.video) return;
        const play = this.visible && !document.hidden && !this.motion.matches && !this.userPaused;
        if (play && this.video.paused) this.video.play().catch(() => {});
        if (!play && !this.video.paused) this.video.pause();
        if (this.videoButton) {
          this.videoButton.hidden = this.motion.matches;
          this.videoButton.setAttribute('aria-label', play ? this.videoButton.dataset.pause : this.videoButton.dataset.play);
          this.videoButton.querySelector('span').textContent = play ? 'Ⅱ' : '▶';
        }
      }
      disconnectedCallback() {
        clearTimeout(this.releaseTimer);
        this.scrollHeld = false;
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.pending);
        this.pending = null;
        cancelAnimationFrame(this.trackFrame);
        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.controller?.abort();
        this.video?.pause();
        this.controller = null;
      }
    }
    customElements.define('addies-home-intro', AddiesHomeIntro);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["addiesdive-real-life"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('addiesdive-real-life-popup')) {
  customElements.define('addiesdive-real-life-popup', class extends HTMLElement {
    connectedCallback() { this.mountFrame = requestAnimationFrame(() => this.initialize()); }
    initialize() {
      if (this.initialized || !this.isConnected) return;
      this.initialized = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.rows = [...this.querySelectorAll('[data-row]')];
      this.paused = new Map(this.rows.map(row => [row, this.dataset.autoplay !== 'true']));
      this.selected = new Map();
      this.animations = new Map();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.dialog = this.querySelector('[data-dialog]');
      this.addEventListener('click', event => {
        const zoom = event.target.closest('[data-zoom]');
        if (zoom) { this.openPhoto(zoom); return; }
        const photo = event.target.closest('[data-photo]');
        if (!photo) return;
        const row = photo.closest('[data-row]');
        if (this.selected.get(row) === photo && this.paused.get(row)) {
          this.paused.set(row, false); this.selected.delete(row);
        } else { this.paused.set(row, true); this.selected.set(row, photo); }
        this.updateSelection(row); this.syncPlayback();
      }, { signal });
      this.addEventListener('pointerdown', event => { const row = event.target.closest('[data-row]'); if (row) row.pointerFocus = true; }, { signal });
      this.addEventListener('keydown', event => { const row = event.target.closest('[data-row]'); if (row) { row.pointerFocus = false; this.syncPlayback(); } }, { signal });
      this.addEventListener('focusin', () => this.syncPlayback(), { signal });
      this.addEventListener('focusout', () => queueMicrotask(() => this.isConnected && this.syncPlayback()), { signal });
      this.dialog.querySelector('[data-close]').addEventListener('click', () => this.dialog.close(), { signal });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, { signal });
      this.dialog.addEventListener('close', () => {
        this.querySelector('[data-large]').removeAttribute('src');
        if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll:true });
        this.syncPlayback();
      }, { signal });
      this.motion.addEventListener('change', () => this.render(), { signal });
      document.addEventListener('visibilitychange', () => this.syncPlayback(), { signal });
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const row = event.target.closest('[data-row]');
        if (row) { this.paused.set(row,true); this.syncPlayback(); }
      }, { signal });
      this.resizeObserver = new ResizeObserver(() => {
        const signature = this.clientWidth + '|' + getComputedStyle(this).getPropertyValue('--arl-width') + '|' + getComputedStyle(this).getPropertyValue('--arl-gap');
        if (signature === this.signature) return;
        this.signature = signature;
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.render());
      });
      this.resizeObserver.observe(this);
      const images = [...this.querySelectorAll('[data-original] img')];
      Promise.all(images.map(img => new Promise(resolve => {
        const settled = () => { if (!img.naturalWidth) img.closest('[data-original]').hidden = true; resolve(); };
        if (img.complete) settled();
        else { img.addEventListener('load',settled,{once:true,signal}); img.addEventListener('error',settled,{once:true,signal}); }
      }))).then(() => { if (signal.aborted) return; this.ready = true; this.render(); });
    }
    updateSelection(row) {
      row.querySelectorAll('[data-photo]').forEach(photo => {
        const selected = photo === this.selected.get(row);
        photo.setAttribute('aria-pressed',String(selected));
        const description = photo.querySelector('img')?.alt || '';
        photo.setAttribute('aria-label',(selected ? this.dataset.playLabel : this.dataset.pauseLabel) + ' — ' + description);
        photo.parentElement.querySelector('[data-zoom]').hidden = !selected;
      });
    }
    openPhoto(zoom) {
      const photo = zoom.parentElement.querySelector('[data-photo]');
      const image = this.querySelector('[data-large]');
      image.src = photo.dataset.full;
      image.alt = photo.querySelector('img').alt;
      const link = this.querySelector('[data-detail]');
      link.hidden = !photo.dataset.link;
      if (photo.dataset.link) link.href = photo.dataset.link; else link.removeAttribute('href');
      this.returnFocus = zoom;
      this.dialog.showModal();
      this.dialog.querySelector('[data-close]').focus();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.mountFrame); cancelAnimationFrame(this.frame);
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort(); this.resizeObserver?.disconnect(); this.stop(); this.initialized = false;
    }
    stop() {
      this.animations?.forEach(animation => animation.cancel());
      this.animations = new Map();
      this.removeAttribute('data-animated');
      this.querySelectorAll('[data-copy]').forEach(copy => copy.remove());
    }
    visualCopy(node) {
      const copy = node.cloneNode(true);
      copy.dataset.copy = ''; copy.setAttribute('aria-hidden','true');
      [copy,...copy.querySelectorAll('*')].forEach(element => {
        element.removeAttribute('id'); element.removeAttribute('data-original');
        element.removeAttribute('data-shopify-editor-block'); element.removeAttribute('data-shopify-editor-block-id');
        if (element.matches('button, a, [tabindex]')) element.setAttribute('tabindex','-1');
        if (element.matches('[data-photo]')) element.setAttribute('aria-pressed','false');
        if (element.matches('[data-zoom]')) element.hidden = true;
      });
      return copy;
    }
    render() {
      const progress = new Map([...this.animations].map(([row, animation]) => [row, (animation.currentTime || 0) / animation.effect.getTiming().duration]));
      this.rows.forEach(row => {
        const photo = this.selected.get(row);
        if (photo?.closest('[data-copy]')) this.selected.delete(row);
      });
      this.stop();
      this.rows.forEach(row => { row.hidden = !row.querySelector('[data-original]:not([hidden])'); });
      if (!this.ready || this.motion.matches || !Element.prototype.animate) return;
      this.setAttribute('data-animated','');
        this.rows.forEach(row => {
          if (row.hidden) return;
          const track = row.querySelector('[data-track]');
          const group = row.querySelector('[data-group]');
          const originals = [...group.querySelectorAll('[data-original]:not([hidden])')];
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          const baseWidth = group.getBoundingClientRect().width;
          if (!baseWidth || !row.clientWidth) return;
          const repeats = Math.max(1, Math.ceil((row.clientWidth + gap) / (baseWidth + gap)));
          for (let i = 1; i < repeats; i++) originals.forEach(item => group.append(this.visualCopy(item)));
          const distance = group.getBoundingClientRect().width + gap;
          track.append(this.visualCopy(group));
          const speed = parseFloat(getComputedStyle(this).getPropertyValue(row.dataset.row === '1' ? '--arl-speed-one' : '--arl-speed-two')) || 30;
          const keyframes = row.dataset.direction === 'right'
            ? [{ transform: `translateX(${-distance}px)` }, { transform: 'translateX(0)' }]
            : [{ transform: 'translateX(0)' }, { transform: `translateX(${-distance}px)` }];
          this.animations.set(row, track.animate(keyframes, { duration: distance / speed * 1000, iterations: Infinity, easing: 'linear' }));
        });

      this.animations.forEach((animation,row) => { if (progress.has(row)) animation.currentTime = progress.get(row) * animation.effect.getTiming().duration; });
      this.rows.forEach(row => this.updateSelection(row));
      this.syncPlayback();
    }
    syncPlayback() {
      this.animations?.forEach((animation,row) => {
        const active = document.activeElement;
        const keyboardFocus = row.contains(active) && active.matches(':focus-visible') && !row.pointerFocus;
        if (document.hidden || this.paused.get(row) || keyboardFocus) animation.pause(); else animation.play();
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["addiesdive-video-produto"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ad-product-film-v2')) {
  customElements.define('ad-product-film-v2', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      if (this.querySelector('.adpf__template')) { this.initializePlayer(); return; }
      this.observer = new MutationObserver(() => {
        if (!this.querySelector('.adpf__template')) return;
        this.observer.disconnect(); this.initializePlayer();
      });
      this.observer.observe(this, {childList:true,subtree:true});
    }
    initializePlayer() {
      if (this.controller) return;
      this.trigger = this.querySelector('.adpf__play');
      this.dialog = this.querySelector('.adpf__dialog');
      this.mediaSlot = this.querySelector('.adpf__slot');
      this.template = this.querySelector('.adpf__template');
      if (!this.trigger || !this.dialog || !this.mediaSlot || !this.template) return;
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.error = this.querySelector('.adpf__error');
      this.select = this.querySelector('[data-popup-variant]');
      this.buy = this.querySelector('[data-popup-buy]');
      this.priceSummary = this.querySelector('[data-popup-price-summary]');
      this.priceValue = this.querySelector('[data-popup-price]');
      this.installmentValue = this.querySelector('[data-popup-installment]');
      this.cartLink = this.querySelector('[data-popup-cart]');
      this.message = this.querySelector('[data-popup-message]');
      this.toggle = this.querySelector('[data-video-toggle]');
      this.progress = this.querySelector('[data-video-progress]');
      this.revision = 0;
      this.trigger.disabled = false;
      this.trigger.addEventListener('click', () => this.openPlayer(), options);
      this.querySelector('.adpf__close').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => {
        this.revision++; this.stopPlayer();
        if (!document.querySelector('ad-product-film-v2 .adpf__dialog[open]')) document.documentElement.classList.remove('adpf-modal-open');
        this.trigger?.focus({preventScroll:true});
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog || this.dataset.closeBackdrop === 'false') return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.select?.addEventListener('change', () => { this.message.textContent=''; this.updatePurchase(); }, options);
      this.buy?.addEventListener('click', () => this.addItem(), options);
      this.cartLink?.addEventListener('click', () => {
        this.openDrawer().catch(()=>{ this.message.textContent=this.dataset.drawerError; });
      }, options);
      this.toggle?.addEventListener('click', () => {
        if (!this.video) return;
        if (this.video.paused) this.playVideo();
        else { this.playbackRequested = false; this.video.pause(); }
      }, options);
      this.progress?.addEventListener('input', () => {
        if (this.video && Number.isFinite(this.video.duration) && this.video.duration > 0) this.video.currentTime = Number(this.progress.value) / 100 * this.video.duration;
      }, options);
      this.updatePurchase();
    }
    selectedOption() { return this.select?.selectedOptions[0]; }
    updatePurchase() {
      if (!this.buy || this.busy) return;
      const option=this.selectedOption();
      const available=option?.dataset.available === 'true';
      this.pageMode=this.dataset.action === 'page' || option?.dataset.quick !== 'true' || this.dataset.fullOptions === 'true';
      const label=this.pageMode ? (this.dataset.action==='page'?this.dataset.pageText:this.dataset.optionsText) : this.dataset.addText;
      this.buy.disabled=!available;
      this.buy.textContent=available?label:this.dataset.unavailableText;
      if (this.priceSummary) this.priceSummary.hidden = !option?.dataset.money;
      if (this.priceValue) this.priceValue.textContent = option?.dataset.money || '';
      if (this.installmentValue) this.installmentValue.textContent = option?.dataset.installment || '';
    }
    openPlayer() {
      if (this.dialog.open || !this.isConnected) return;
      document.querySelectorAll('ad-product-film-v2 .adpf__dialog[open]').forEach(dialog => dialog.close());
      if (!this.busy && this.select) {
        const id = new URL(location.href).searchParams.get('variant');
        if (id && Array.from(this.select.options).some(option => option.value === id)) this.select.value = id;
        this.message.textContent = ''; this.updatePurchase();
      }
      this.stopPlayer();
      this.error.hidden = true;
      const fragment = this.template.content.cloneNode(true);
      const video = fragment.querySelector('video');
      this.video = video;
      this.readyRetries = 0;
      this.playbackRequested = this.dataset.autoplay !== 'false';
      if (video) {
        this.muteVideo(video);
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        [video, ...video.querySelectorAll('source')].forEach(source => {
          const deferred = source.getAttribute('data-src');
          if (!source.getAttribute('src') && deferred) source.setAttribute('src', deferred);
        });
        video.autoplay = this.playbackRequested;
        video.preload = 'auto';
        this.bindMedia(video);
      }
      this.mediaSlot.replaceChildren(fragment);
      this.dialog.showModal();
      document.documentElement.classList.add('adpf-modal-open');
      this.querySelector('.adpf__close').focus({preventScroll: true});
      if (!video) { this.error.hidden = false; this.syncPlayback('error'); return; }
      this.syncPlayback(this.playbackRequested ? 'loading' : 'paused');
      if (this.playbackRequested) this.playVideo();
    }
    bindMedia(video) {
      this.mediaController = new AbortController();
      const {signal} = this.mediaController;
      const active = () => this.video === video && this.dialog.open;
      const resume = () => {
        if (!active() || !this.playbackRequested || !video.paused || this.playbackPending || this.readyRetries >= 1) return;
        this.readyRetries++; this.playVideo();
      };
      video.addEventListener('volumechange', () => this.muteVideo(video), {signal});
      video.addEventListener('play', () => { if (active()) this.syncPlayback(video.readyState >= 3 ? 'playing' : 'loading'); }, {signal});
      video.addEventListener('playing', () => { if (active()) { this.error.hidden = true; this.syncPlayback('playing'); } }, {signal});
      video.addEventListener('waiting', () => { if (active() && this.playbackRequested) this.syncPlayback('loading'); }, {signal});
      video.addEventListener('pause', () => { if (active() && !this.playbackPending) this.syncPlayback('paused'); }, {signal});
      video.addEventListener('ended', () => { if (active()) { this.playbackRequested = false; this.syncPlayback('paused'); } }, {signal});
      video.addEventListener('loadeddata', resume, {signal});
      video.addEventListener('canplay', resume, {signal});
      video.addEventListener('error', () => {
        if (!active()) return;
        this.playbackRequested = false; this.error.hidden = false; this.syncPlayback('error');
      }, {signal});
      video.addEventListener('timeupdate', () => {
        if (!active() || !this.progress) return;
        const duration = video.duration;
        this.progress.disabled = !Number.isFinite(duration) || duration <= 0;
        if (!this.progress.disabled) this.progress.value = String(video.currentTime / duration * 100);
      }, {signal});
    }
    syncPlayback(state) {
      this.dialog.dataset.playback = state;
      this.mediaSlot.setAttribute('aria-busy', String(state === 'loading'));
      const paused = this.video?.paused ?? true;
      this.dialog.dataset.paused = String(paused);
      this.toggle?.setAttribute('aria-label', paused ? 'Reproduzir vídeo' : 'Pausar vídeo');
      if (this.toggle) this.toggle.disabled = !paused && this.dataset.pauseOnClick === 'false';
    }
    muteVideo(video = this.video) {
      if (!video) return;
      video.defaultMuted = true;
      if (!video.muted) video.muted = true;
      if (video.volume !== 0) video.volume = 0;
      video.controls = false;
    }
    playVideo() {
      const video = this.video;
      if (!video || !this.dialog.open || this.playbackPending) return;
      this.playbackRequested = true;
      this.playbackPending = true;
      this.error.hidden = true;
      this.muteVideo(video);
      this.syncPlayback('loading');
      let playback;
      try { playback = video.play(); } catch (error) { playback = Promise.reject(error); }
      Promise.resolve(playback).then(() => {
        if (this.video !== video || !this.dialog.open) return;
        this.error.hidden = true;
        this.syncPlayback(video.readyState >= 3 ? 'playing' : 'loading');
      }).catch(error => {
        if (this.video !== video || !this.dialog.open) return;
        if (error?.name === 'AbortError' && this.playbackRequested) return;
        this.playbackRequested = false;
        this.error.hidden = error?.name === 'NotAllowedError';
        this.syncPlayback(error?.name === 'NotAllowedError' ? 'blocked' : 'error');
      }).finally(() => {
        if (this.video !== video) return;
        this.playbackPending = false;
        if (this.dialog.open && this.playbackRequested && video.paused && video.readyState >= 3 && this.readyRetries < 1) {
          this.readyRetries++; this.playVideo();
        }
      });
    }
    applySections(sections) {
      if (typeof sections?.['offcanvas-cart'] !== 'string') return false;
      const doc=new DOMParser().parseFromString(sections['offcanvas-cart'],'text/html');
      const next=doc.querySelector('cart-container');
      const current=document.querySelector('#offcanvas-cart cart-container');
      if (!next || !current) return false;
      current.replaceWith(next);
      if (typeof sections['cart-count-badge']==='string') {
        const badgeDoc=new DOMParser().parseFromString(sections['cart-count-badge'],'text/html');
        const badge=badgeDoc.querySelector('.cart-count-badge');
        if (badge) document.querySelectorAll('.cart-count-badge').forEach(currentBadge=>currentBadge.replaceWith(badge.cloneNode(true)));
      }
      window.dispatchEvent(new CustomEvent('ks.cart.reloaded'));
      return true;
    }
    showDrawer() {
      const drawer=document.querySelector('#offcanvas-cart');
      const Offcanvas=window.bootstrap?.Offcanvas;
      if (!drawer || !Offcanvas) throw new Error(this.dataset.drawerError);
      if (this.dialog.open) this.dialog.close();
      document.querySelectorAll('.offcanvas.show').forEach(panel=>{if(panel!==drawer)Offcanvas.getOrCreateInstance(panel).hide();});
      Offcanvas.getOrCreateInstance(drawer).show(this.trigger);
    }
    async openDrawer(sections, revision) {
      if (!this.applySections(sections)) {
        const url=new URL(location.href);url.searchParams.set('sections','cart-count-badge,offcanvas-cart');
        const response=await fetch(url,{credentials:'same-origin',headers:{Accept:'application/json'}});
        if (!response.ok || !this.applySections(await response.json())) throw new Error(this.dataset.drawerError);
      }
      if (!this.isConnected || (revision !== undefined && (!this.dialog.open || this.revision !== revision))) return;
      this.showDrawer();
    }
    async addItem() {
      if (this.busy || this.buy.disabled) return;
      const option=this.selectedOption();
      if (this.pageMode) { location.assign(option?.dataset.url || this.dataset.productUrl);return; }
      const id=Number(option?.value);
      if (!Number.isSafeInteger(id)||id<=0||option.dataset.available!=='true'||option.dataset.quick!=='true') return;
      const revision=this.revision;
      this.busy=true;
      this.buy.disabled=true;this.buy.setAttribute('aria-busy','true');
      if (this.select) this.select.disabled=true;
      if (this.cartLink) this.cartLink.disabled=true;
      this.buy.textContent=this.dataset.loadingText;this.message.textContent='';
      let confirmed=false;
      try {
        const response=await fetch(this.dataset.addUrl,{
          method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({items:[{id,quantity:1}],sections:['cart-count-badge','offcanvas-cart'],sections_url:location.pathname+location.search})
        });
        let data;try{data=await response.json();}catch{throw new Error(this.dataset.errorText);}
        if (!response.ok) throw new Error([typeof data.description==='string'?data.description:'',this.dataset.errorText].filter(Boolean).join(' '));
        if (!Array.isArray(data.items)||!data.items.some(item=>Number(item.variant_id||item.id)===id)) throw new Error(this.dataset.errorText);
        confirmed=true;
        if (!this.isConnected) return;
        window.dispatchEvent(new CustomEvent('ks.cart.added',{detail:data}));
        if (this.cartLink) this.cartLink.hidden=false;
        if (this.dataset.afterAdd==='drawer'&&this.dialog.open&&this.revision===revision) {
          await this.openDrawer(data.sections, revision);
        } else this.applySections(data.sections);
        this.message.textContent=this.dataset.showSuccess==='true'?this.dataset.successText:'';
        if (this.cartLink) this.cartLink.hidden=false;
      } catch(error) {
        if (this.isConnected) this.message.textContent=confirmed?[this.dataset.successText,this.dataset.drawerError].join(' '):(error.message||this.dataset.errorText);
      } finally {
        this.busy=false;
        if (this.select) this.select.disabled=false;
        if (this.cartLink) this.cartLink.disabled=false;
        this.buy.removeAttribute('aria-busy');
        if (this.isConnected) this.updatePurchase();
      }
    }
    stopPlayer() {
      this.playbackRequested = false; this.playbackPending = false;
      this.mediaSlot?.setAttribute('aria-busy', 'false');
      this.mediaController?.abort();
      this.mediaSlot?.querySelectorAll('video').forEach(video=>{
        video.autoplay=false;video.pause();video.removeAttribute('src');video.querySelectorAll('source').forEach(source=>source.remove());video.load();
      });
      this.mediaSlot?.replaceChildren();this.video=null;
      if (this.progress) {this.progress.value='0';this.progress.disabled=true;}
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      if (this.dialog?.open) this.dialog.close();
      this.stopPlayer();this.controller?.abort();this.controller=null;
      if (!document.querySelector('ad-product-film-v2 .adpf__dialog[open]')) document.documentElement.classList.remove('adpf-modal-open');
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommended-products"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('ad-vitrine-loader-v2')) {
  customElements.define('ad-vitrine-loader-v2', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.source === 'manual' || this.dataset.ready === 'true' || this.loading) return;
      this.loading = true;
      this.controller = new AbortController();
      const url = new URL(this.dataset.url, location.origin);
      url.searchParams.set('section_id', this.dataset.section);
      url.searchParams.set('product_id', this.dataset.product);
      url.searchParams.set('limit', this.dataset.limit);
      url.searchParams.set('intent', this.dataset.intent);
      fetch(url, {signal: this.controller.signal})
        .then(response => { if (!response.ok) throw new Error('Recommendations unavailable'); return response.text(); })
        .then(html => {
          const node = new DOMParser().parseFromString(html, 'text/html').querySelector('ad-vitrine-loader-v2');
          if (!node || !this.isConnected) return;
          this.dataset.ready = 'true';
          this.innerHTML = node.innerHTML;
        })
        .catch(error => { if (error.name !== 'AbortError') this.dataset.ready = 'true'; })
        .finally(() => { this.loading = false; });
    }
    disconnectedCallback() { this.controller?.abort(); this.loading = false; }
  });
}

  if (!customElements.get('ad-vitrine-cards-v2')) {
    customElements.define('ad-vitrine-cards-v2', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.track = this.querySelector('.ad-vitrine__track');
        this.navigation = this.querySelector('.ad-vitrine__navigation');
        if (!this.track) return;
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.querySelectorAll('[data-advc-extra]').forEach(link => { link.hidden = true; });
        this.querySelectorAll('[data-advc-more]').forEach(button => { button.hidden = !button.closest('[data-advc-card]').querySelector('[data-advc-extra]'); });
        this.addEventListener('click', event => {
          const variant = event.target.closest('[data-advc-variant]');
          if (variant && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
            event.preventDefault();
            const card = variant.closest('[data-advc-card]');
            card.querySelectorAll('[data-advc-variant]').forEach(link => link.setAttribute('aria-pressed', String(link === variant)));
            card.querySelectorAll('[data-advc-product-link]').forEach(link => { link.href = variant.href; });
            const price = card.querySelector('[data-advc-price-current]');
            if (price) price.textContent = variant.dataset.price;
            const compare = card.querySelector('[data-advc-compare]');
            if (compare) { compare.hidden = variant.dataset.onSale !== 'true'; compare.textContent = variant.dataset.compare; }
            card.querySelector('[data-advc-sold-out]').hidden = variant.dataset.available === 'true';
            card.querySelector('[data-advc-current-variant]').textContent = variant.dataset.label;
            const image = card.querySelector('.advc-main-image');
            if (variant.dataset.image) {
              image.alt = card.querySelector('.advc-title').textContent.trim() + ' — ' + variant.dataset.label;
              image.srcset = variant.dataset.srcset;
              image.src = variant.dataset.image;
              image.hidden = false;
              card.querySelector('[data-advc-missing]').hidden = true;
            } else { image.hidden = true; card.querySelector('[data-advc-missing]').hidden = false; }
            this.querySelector('[data-advc-status]').textContent = variant.dataset.label + ' — ' + variant.dataset.price;
          }
          const more = event.target.closest('[data-advc-more]');
          if (more) {
            const expanded = more.getAttribute('aria-expanded') !== 'true';
            more.closest('[data-advc-card]').querySelectorAll('[data-advc-extra]').forEach(link => { link.hidden = !expanded && link.getAttribute('aria-pressed') !== 'true'; });
            more.setAttribute('aria-expanded', String(expanded));
            more.textContent = expanded ? 'Ver menos opções' : 'Ver mais opções';
          }
        }, {signal});
        this.addEventListener('keydown', event => {
          const link = event.target.closest('[data-advc-variant]');
          if (event.key === ' ' && link) { event.preventDefault(); link.click(); }
        }, {signal});
        this.addEventListener('error', event => {
          if (!event.target.matches?.('.advc-main-image')) return;
          const card = event.target.closest('[data-advc-card]');
          event.target.hidden = true; card.querySelector('[data-advc-missing]').hidden = false;
        }, {signal,capture:true});
        if (this.querySelector('[data-advc-theme-wishlist]')) customElements.whenDefined('wishlist-button').then(() => {
          if (!this.isConnected || !document.querySelector('wishlist-container')) return;
          this.querySelectorAll('[data-advc-theme-wishlist]').forEach(wishlist => { wishlist.hidden = false; });
        });

        this.buttons = Array.from(this.querySelectorAll('[data-direction]'));
        this.counter = this.querySelector('.ad-vitrine__counter');
        this.update = () => {
          const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
          const left = this.track.scrollLeft;
          if (this.navigation) this.navigation.hidden = max <= 2 || (!this.buttons.length && !this.counter);
          const previous = this.buttons.find(button => button.dataset.direction === '-1');
          if (previous) previous.disabled = left <= 2;
          const next = this.buttons.find(button => button.dataset.direction === '1');
          if (next) next.disabled = left >= max - 2;
          const cards = Array.from(this.track.children);
          const edge = this.track.getBoundingClientRect().left;
          const index = cards.reduce((closest, card, i) => Math.abs(card.getBoundingClientRect().left - edge) < Math.abs(cards[closest].getBoundingClientRect().left - edge) ? i : closest, 0);
          if (this.counter) this.counter.textContent = `${String(index + 1).padStart(2, '0')} / ${String(cards.length).padStart(2, '0')}`;
        };
        this.buttons.forEach(button => button.addEventListener('click', () => {
          const first = this.track.firstElementChild;
          if (!first) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const step = first.getBoundingClientRect().width + gap;
          this.track.scrollBy({left: Number(button.dataset.direction) * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        }, {signal}));
        this.track.addEventListener('scroll', this.update, {passive: true, signal});
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.abortController = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
